import { OrganizationSubscriptionService } from './../../../modules/shared/services/organization-subscription.service';
import { SubscriptionFeatureLimitM } from './../../../modules/shared/models/organization-subscription/subscription-feature-limit.modal';
import { FeatureSubscriptionInfoEnums } from './../../../modules/shared/enums/feature-subscription-info.enum';
import { DefaultChannelPermissionModel } from './models/default-channel-permission.model';
import { TypeGroupIds } from './../../../modules/shared/constants/category-groupid.constants';
import { OrganizationFullDetailsModels } from './../../../models/organization-full-details.models';
import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { validateFiles, uploadFiles } from './../../../shared/upload-files';
import { Status } from './../../../models/statusEnums';
import { ContactService } from './../../../contacts/contactService';
import { ObjectNames } from './../../../shared/constants';
import { AccountService } from './../../../accounts/accountService';
import { DatePipe } from '@angular/common';
import { ConfirmationService, MessageService, TreeNode } from 'primeng/api';
import { TabView } from "primeng/tabview";
import { Accordion } from "primeng/accordion";
import { AppMainService } from './../../../app-main.service';
import { AppMainComponent } from './../../../app.main.component';
import { ConfigurationService } from './../../configurationService';
import { FormGroupDirective, FormBuilder } from '@angular/forms';
import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { PermissionService } from '../../../service/permission.service';
import { addInList } from './../../../modules/shared/helpers';
import { TranslocoService } from '@ngneat/transloco';
import { JobFunction } from '../../fsm/territory/models/job-function.model';
import { JobTypeService } from './services/job-type.services';
import { forkJoin, Subject, takeUntil, map } from 'rxjs';
import { AssociatedUser } from './models/associated-user.model';
import { JOB_TYPE } from '../constant/users-module-name';
import { RoleHierarchyService } from '../role-hierarchy/services/role-hierarchy.service';
import { UserProfileService } from '../profile/services/profile.services';
import { ChannelN } from 'src/app/modules/shared/models/channel.model';
import { SharedChannelService } from 'src/app/modules/shared/services/channel.service';
import { AccountModuleId } from 'src/app/modules/shared/constants/modules.constant';
import { ChannelWisePermissionService } from './services/channel-permission.services';
import { AddEditAddressModalService } from 'src/app/modules/shared/components/address/address-add-update-modal/address-add-update-modal.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-configuration-user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.scss']
})
export class ConfigurationUserComponent implements OnInit, AfterViewInit, OnDestroy {

  activeIndex: number = 0;
  activeAccordionIndex: number = 0;
  selectedWindow = 'user';
  defaultProfileImage = `${environment.assestsBasePath}layout/images/avatar5.png`;

  //pagination
  tableShowMore: number[] = [15, 30, 50, 100];
  first = 0;

  //address
  addressInput = "";
  formattedaddress = "";
  stateList = [];
  cityList = [];
  latitude = 0;
  longitude = 0;
  addressInputForPostal = "";
  formattedAddressForPostal = "";

  //Contacts
  displayAddContactData = false;
  addEditContactHeader;
  tempContactStage = {
    "id": 0,
    "name": "",
    "contactAssociationTypeId": 0,
    "contacts": [] as any[],
    "count": 0,
    "displayOrder": 0,
    "description": "",
    "createdDate": new Date().toISOString(),
    "updatedDate": new Date().toISOString(),
  }
  contactDataTemp;

  emailConfig;
  phoneConfig;
  socialConfig;
  contactTypeId = 0;
  selectedContactDataType;


  contactDataTypes = [
    { id: 6, name: "Annual Income", code: "income" },
    { id: 0, name: "Contact Type", code: "contact type" },
    { id: 7, name: "Degree", code: "degree" },
    { id: 9, name: "Email Types", code: "email type" },
    { id: 8, name: "Field of Study", code: "study field" },
    { id: 1, name: "Gender", code: "gender" },
    { id: 2, name: "Language Spoken", code: "language" },
    { id: 4, name: "Marital Status", code: "marital" },
    { id: 10, name: "Phone Types", code: "phone type" },
    { id: 3, name: "Relationship Status", code: "relation" },
    { id: 11, name: "Social Profile Types", code: "social type" },
    { id: 5, name: "Source of Contact", code: "contact source" },
    { id: 12, name: "Roles", code: "role" },
    { id: 13, name: "Title", code: "title" },
    { id: 14, name: "Job Type", code: "jobType" },
  ]
  contactTypes: any[] = [];
  genders: any[] = [];
  languages: any[] = [];
  relations: any[] = [];
  maritals: any[] = [];
  contactSources: any[] = [];
  incomes: any[] = [];
  degrees: any[] = [];
  studyFields: any[] = [];
  contactRoles: any[] = [];


  val: boolean;

  filters: any[] = [];
  filterValues: any[] = [];
  filterValuesLists: any[] = [];
  countryId: Number;
  allCountries: any[] = [];
  allStates: any[] = [];
  allPStates: any[] = [];
  allCities: any[] = [];
  allPCities: any[] = [];
  allCitiesLists: any[] = [];
  timeZoneList: any[] = [];
  ruleLists: any[] = [];

  emailtype: any;
  phonetype: any;
  socials: any;

  // user
  allRoles: any[] = [];
  allUsers: any[] = [];
  allUsersList: any[] = [];
  roleWiseUsers: any[] = [];
  activeRoleWiseUsers: any[] = [];
  activeUsers: any[] = [];
  searchUserText: string = '';
  allUserGroup: any[] = [];
  userTemplateConfig;
  allUserTemplates: any[] = [];

  templateUserTemp = {
    "id": 0,
    "templateName": "",
    "pipeId": 0,
    "pipe": {
      "id": 0,
      "name": "",
    },
    "createdUser": "",
    "updatedUser": "",
    "createdBy": this.app.user.userId,
    "createdDate": new Date().toISOString(),
    "updatedBy": this.app.user.organizationId,
    "updatedDate": new Date().toISOString(),
    "isActive": "Yes",
    "labels_info": [] as any[],
    "labels_business": [] as any[],
    "labels_contact": [] as any[],
    "labels_address": [] as any[],
  };

  configMenuUserItems;
  addEditUserHeader = '';
  displayEditUserTemplate = false;

  availableUserLabels_info: any[] = [];
  selectedUserLabels_info: any[] = [];
  availableUserLabels_address: any[] = [];
  selectedUserLabels_address: any[] = [];
  availableUserLabels_other_info: any[] = [];
  selectedUserLabels_other_info: any[] = [];

  selectedUserCheck1 = true;
  selectedUserCheck2 = true;
  selectedUserCheck3 = true;

  displaySwapUserLabels = false;
  displayAddUserGroup = false;
  displayAddUser = false;

  userDataTypes = [
    { id: 6, name: "Annual Income", code: "income" },
    { id: 7, name: "Degree", code: "degree" },
    // { id: 9, name: "Email Types", code: "email type" },
    { id: 8, name: "Field of Study", code: "study field" },
    { id: 1, name: "Gender", code: "gender" },
    { id: 2, name: "Language Spoken", code: "language" },
    { id: 4, name: "Marital Status", code: "marital" },
    // { id: 10, name: "Phone Types", code: "phone type" },
    // { id: 11, name: "Social Profile Types", code: "social type" },
    { id: 9, name: "Job Type", code: "jobType" },
  ];
  currentModule = '';

  selectedParent;
  groupName;
  tempUserGroup = {
    "id": 0,
    "createdSource": "",
    "updatedSource": "",
    "createdBy": "",
    "updatedBy": "",
    "createdDate": "",
    "updatedDate": "",
    "groupId": "",
    "group": {
      "id": 0,
      "createdSource": "",
      "updatedSource": "",
      "createdBy": "",
      "updatedBy": "",
      "createdDate": "",
      "updatedDate": "",
      "name": "",
      "isValid": "",
      "parentGroupId": 0,
      "parentGroup": {
        "groupId": null
      },
    },
    "users": [] as any[],
    "groupOwners": [] as any[],
    "organizationId": 0,
    "statusId": 1,
  }

  @ViewChild('addEditUserForm') addEditUserForm: FormGroupDirective;
  @ViewChild('userGroupForm') userGroupForm: FormGroupDirective;
  @ViewChild(TabView) tabView: TabView;
  @ViewChild(Accordion) accordion: Accordion;


  tempUser;
  selectedUserData;

  departments: any[] = [];
  countries: any[] = [];

  userData;
  isDisabledUserEdit = false;
  userProfileAttachment;

  selectedUserRole;
  selectedParentRole;
  selectedUserPhone = '';
  selectedSocialProfile = '';
  selectedGender;
  maxDate = new Date();
  selectedMaritialStatus;
  selectedDegree;
  selectedAnnulIncome;
  selectedRelationshipStatus;
  selectedFieldOfStudy;
  selectedReportsTo: any[] = [];
  selectedMCountry;
  selectedMState;
  selectedMCity;
  selectedPCountry;
  selectedPState;
  selectedPCity;
  selectedTimeZone;
  selectedAssistant;
  selectedDepartment;
  selectedLanguages;
  selectedWorkingLocation;
  isActive: boolean = true;

  displayPermission = false;
  index = 0;

  allowedExtensions = ['.png', '.jpg', '.jpeg', '.gif']; // For the attachment files

  isDisabledUserGroupEdit = false;
  addEditUserGroupHeader = '';
  showAddMore: boolean = false;
  configTemp;
  displayAddUserDropdownData = false;
  userPermisions: any[] = [];
  allViewPermissions: boolean = true;
  allCreatePermissions: boolean = true;
  allEditPermissions: boolean = true;
  allDeletePermissions: boolean = true;
  allExportPermissions: boolean = true;

  selectedUser;

  alluserPermissionCustom: any[];
  reportPermissionData: any[] = [];

  displayOpenOrgChart = false;
  orgData: TreeNode[];
  selectedNode: TreeNode;

  // add/edit user popup
  showUserformaddresfields: boolean = false;
  showUserformOtherfields: boolean = false;
  selectedUserLabelsFieldsCount: number = 0;

  formSubmitted = false;
  fieldTypeSelectionError = false;
  invalidData = false;

  userTranslate = {
    User: "",
    Group: "",
    FieldData: "",
    AddUserHeading: "",
    ShowLess: "",
    ShowMore: "",
    ViewUserGroupHeading: "",
    AddUserGroupHeading: "",
    EditUserGroupHeading: "",
    CopyUserGroupHeading: "",
    AddFieldDataHeading: "",
    ViewUserHeading: "",
    EditUserHeading: "",
    CopyUserHeading: "",
    DeleteConfirmationHeader: "",
    UserDeleteConfirmationMsg: "",
    UserGroupDeleteConfirmationMsg: "",
    GenderDeleteConfirmationMsg: "",
    LanguageDeleteConfirmationMsg: "",
    RelationshipStatusDeleteConfirmationMsg: "",
    MaritalStatusDeleteConfirmationMsg: "",
    AnnualIncomeDeleteConfirmationMsg: "",
    DegreeDeleteConfirmationMsg: "",
    EmailTyeDeleteConfirmationMsg: "",
    PhoneTypeDeleteConfirmationMsg: "",
    SocialTypeDeleteConfirmationMsg: "",
    EditFieldDataHeading: ""
  }

  organizationDetails: OrganizationFullDetailsModels;

  /* Subject to unsubscribe */
  private ngUnsubscribe = new Subject<void>();

  jobTypes: JobFunction[] = [];
  displayTransferJobTypeModal: boolean = false;
  jobTypeForTransfer: any;
  filteredJobTypes: JobFunction[] = [];
  selectedJobTypeForTransfer: any;
  jobTypeSelectionError: boolean = false;
  displayAssociatedUsersModal: boolean = false;
  associatedUsers: AssociatedUser[] = [];
  readonly subModuleName: string = JOB_TYPE;
  jobTypeIdForSelectedAssociatedUser: number;

  allRoleHierarchy: any;
  selectedRoleHierarchy: any;
  selectedJobType: any = null;
  allProfile: any;
  selectedProfile: any;
  roleIdTemp: number;
  isProfileSelected: boolean = false;
  systemDefaultChannelPermission: DefaultChannelPermissionModel;
  permissionsTB: Array<any> = [];
  deletedPermissionsTB: Array<any> = [];
  displayAddEditPermission = false;
  permissionHeader;
  tempPermission: any;
  channelsN: ChannelN[] = []; // Will Change
  channelsVM: ChannelN[] = [];
  selectedChannelN: any;
  selectedPermission: any;
  permissionActiveInactiveToggle: boolean = true;
  userForChannelPermission: any;
  indexOfEditPermissionData: number;
  workingLocation: any[] = [];
  timeZoneId: number = null;

  subscriptionLimit: SubscriptionFeatureLimitM = null;

  constructor(
    private addEditAddressModalService: AddEditAddressModalService,
    private service: ConfigurationService,
    public app: AppMainComponent,
    private appMainService: AppMainService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    public datepipe: DatePipe,
    private contactService: ContactService,
    private accountService: AccountService,
    private fb1: FormBuilder,
    private fb2: FormBuilder,
    private fb3: FormBuilder,
    private permissionService: PermissionService,
    private translocoService: TranslocoService,
    private jobTypeService: JobTypeService,
    private roleHierarchyService: RoleHierarchyService,
    private userProfileService: UserProfileService,
    private sharedChannelService: SharedChannelService,
    private channelWisePermissionService: ChannelWisePermissionService,
    private organizationSubscriptionService: OrganizationSubscriptionService

  ) {
    this.organizationDetails = app.organizationData;
  }

  ngOnInit(): void {
    //this.getTimeZoneId();
    this.getTranslatedData();
    const userPermissions = this.permissionService.getPemrissionData();
    const userUerPermission = userPermissions.find(obj => obj.objectName === ObjectNames.USER);
    this.alluserPermissionCustom = userUerPermission.permissions;
    this.configMenuUserItems = [
      {
        label: this.userTranslate.User,
        icon: 'pi pi-plus',
        command: () => {
          this.loadMandatoryData('add');
          this.showAddMore = true;
        }
      },
      {
        label: this.userTranslate.Group,
        icon: 'pi pi-plus',
        command: () => {
          this.showAddEditUserGroup(null, 'add');
        }
      },
      {
        label: this.userTranslate.FieldData,
        icon: 'pi pi-plus',
        command: () => {
          this.selectedContactDataType = null;
          this.showAddContactData('user');
        }
      },
    ];
    this.checkSubscriptionLimit();
    // this.getUserConfiguration();
    // this.getUsersList();
    //this.getRolesList();
    //this.getUserGroupList();
    //this.SelectAllCountries();
    //this.getRoleWiseUserList();
    //this.getJobTypes();
    //this.getRoleHierarchyList();
    this.getProfileList();
    this.getSystemDefaultChannel();
    //this.getUserWorkingLocation();
    // this.service.getDepartments().subscribe(resp => {
    //   ////console.log('departments', resp);
    //   this.departments = resp;
    //   this.departments.sort(function (a, b) {
    //     var nameA = a.name.toLowerCase(), nameB = b.name.toLowerCase()
    //     if (nameA < nameB) //sort string ascending
    //       return -1
    //     if (nameA > nameB)
    //       return 1
    //     return 0 //default return value (no sorting)
    //   })
    // });

    // this.contactService.getAllContactSource().then(sources => {
    //   this.contactSources = sources;
    // });

    //this.loadContactRoles();
    //this.appMainService.isShowSpinner('loadAnnualIncome')
    // this.contactService.getAllAnnualIncome()
    //   .then(incomes => {
    //     this.incomes = incomes;
    //     this.appMainService.isHideSpinner('loadAnnualIncome')
    //   })
    //   .catch(err => {
    //     this.appMainService.isHideSpinner('loadAnnualIncome')
    //   });

    // this.appMainService.isShowSpinner('loadDegree')
    // this.contactService.getAllDegree().then(degrees => {
    //   this.degrees = degrees;
    //   this.appMainService.isHideSpinner('loadDegree')
    // }).catch(err => {
    //   this.appMainService.isHideSpinner('loadDegree')
    // });

    // this.appMainService.isShowSpinner('loadStudyFields')
    // this.contactService.getAllStudyField().then(fields => {
    //   this.studyFields = fields;
    //   this.appMainService.isHideSpinner('loadStudyFields')
    // }).catch(err => {
    //   this.appMainService.isHideSpinner('loadStudyFields')
    // });


    // this.contactService.getAllContactTypes().then(types => {
    //   this.contactTypes = types;
    // });

    // this.appMainService.isShowSpinner('loadGenders')
    // this.contactService.getAllGender().then(genders => {
    //   this.genders = genders;
    //   this.appMainService.isHideSpinner('loadGenders')
    // }).catch(err => {
    //   this.appMainService.isHideSpinner('loadGenders')
    // });

    // this.appMainService.isShowSpinner('loadLanguages')
    // this.contactService.getAllLanguage().then(languages => {
    //   this.languages = languages;
    //   this.appMainService.isHideSpinner('loadLanguages')
    // }).catch(err => {
    //   this.appMainService.isHideSpinner('loadLanguages')
    // });

    // this.appMainService.isShowSpinner('loadRelations')
    // this.contactService.getAllRelationshipStatus().then(status => {
    //   this.relations = status;
    //   this.appMainService.isHideSpinner('loadRelations')
    // }).catch(err => {
    //   this.appMainService.isHideSpinner('loadRelations')
    // });

    // this.appMainService.isShowSpinner('loadMaritals')
    // this.contactService.getAllMaritalStatus().then(status => {
    //   this.maritals = status;
    //   this.appMainService.isHideSpinner('loadMaritals')
    // }).catch(err => {
    //   this.appMainService.isHideSpinner('loadMaritals')
    // });

    // this.accountService.getTimezone().then(timezoneList => {
    //   this.timeZoneList = timezoneList;
    // });

    // this.service.getMaritialStatus().subscribe(resp => {
    //   this.maritialStatuses = resp;
    // });

    // this.service.getFieldOfStudies().subscribe(resp => {
    //   this.fieldOfStudies = resp;
    // });

  }

  ngAfterViewInit() {
    this.onTabChange(null);
  }

  onTabChange(event) {
    const selectedTabHeader = this.tabView?.tabs[this.activeIndex]?.header;
    switch (selectedTabHeader) {
      case 'Users':
        this.getUsersList();
        break;
      case 'Groups':
        this.getUserGroupList()
        break;
      case 'Template':
        this.getUserConfiguration();
        break;
      default:
        this.activeAccordionIndex = 0;
        this.onOpenAccordion(null);
    }
  }

  onOpenAccordion(event) {
    if (event) {
      this.activeAccordionIndex = (event.index);
    }
    const selectedTabHeader = this.accordion?.tabs[this.activeAccordionIndex]?.header;
    switch (selectedTabHeader) {
      case 'Annual Income':
        this.loadAnnualIncome();
        break;
      case 'Degree':
        this.loadDegrees();
        break;
      case 'Field Of Study':
        this.loadStudy();
        break;
      case 'Gender':
        this.loadGenders();
        break;
      case 'Language Spoken':
        this.loadLanguages();
        break;
      case 'Marital Status':
        this.loadMarial();
        break;
      default:
        this.getJobTypes();
    }
  }

  loadAnnualIncome() {
    this.contactService.getAnnualIncomes()
      .then(incomes => {
        this.incomes = incomes;
        this.appMainService.isHideSpinner('loadAnnualIncome')
      })
      .catch(err => {
        this.appMainService.isHideSpinner('loadAnnualIncome')
      });
  }

  loadDegrees() {
    this.appMainService.isShowSpinner('loadDegree')
    this.contactService.getDegrees().then(degrees => {
      this.degrees = degrees;
      this.appMainService.isHideSpinner('loadDegree')
    }).catch(err => {
      this.appMainService.isHideSpinner('loadDegree')
    });
  }

  loadStudy() {
    this.appMainService.isShowSpinner('loadStudyFields')
    this.contactService.getStudyFields().then(fields => {
      this.studyFields = fields;
      this.appMainService.isHideSpinner('loadStudyFields')
    }).catch(err => {
      this.appMainService.isHideSpinner('loadStudyFields')
    });
  }

  loadGenders() {
    this.appMainService.isShowSpinner('loadGenders')
    this.contactService.getGenders().then(genders => {
      this.genders = genders;
      this.appMainService.isHideSpinner('loadGenders')
    }).catch(err => {
      this.appMainService.isHideSpinner('loadGenders')
    });
  }

  loadLanguages() {
    this.appMainService.isShowSpinner('loadLanguages')
    this.contactService.getLanguages().then(languages => {
      this.languages = languages;
      this.appMainService.isHideSpinner('loadLanguages')
    }).catch(err => {
      this.appMainService.isHideSpinner('loadLanguages')
    });
  }

  loadMarial() {
    this.appMainService.isShowSpinner('loadMaritals')
    this.contactService.getAllMaritalStatuses().then(status => {
      this.maritals = status;
      this.appMainService.isHideSpinner('loadMaritals')
    }).catch(err => {
      this.appMainService.isHideSpinner('loadMaritals')
    });
  }

  loadMandatoryData(action, savedData?) {
    this.appMainService.isShowSpinner('loadData');
    forkJoin({
      templates: this.service.getConfigurationByModuleName('User'),
      roles: this.roleHierarchyService.getAllRoleHierarchy(),
      genders: this.contactService.getAllGender(),
      jobTypes: this.jobTypeService.getJobTypes(),
      departments: this.service.getDepartments(),
      languages: this.contactService.getAllLanguage(),
      maritals: this.contactService.getAllMaritalStatus(),
      degrees: this.contactService.getAllDegree(),
      incomes: this.contactService.getAllAnnualIncome(),
      timeZoneId: this.service.getTimeZoneId(this.app.organizationData?.id),
      timeZoneList: this.accountService.getTimezone(),
      study: this.contactService.getAllStudyField(),
      locations: this.jobTypeService.getUserWorkingLocation(),
      country: this.accountService.getAllCountries(),
    }).subscribe({
      next: ({ templates, roles, genders, jobTypes, departments, languages, maritals, degrees, incomes, timeZoneId, timeZoneList, study, locations, country }) => {
        this.appMainService.isHideSpinner('loadData');
        this.loadTemplateData(templates);
        const convertedData = this.convertJsonForTreeSelect(roles);
        this.allRoleHierarchy = [...convertedData];
        this.genders = genders;
        this.jobTypes = jobTypes;
        this.departments = departments;
        this.departments.sort(function (a, b) {
          var nameA = a.name.toLowerCase(), nameB = b.name.toLowerCase()
          if (nameA < nameB) //sort string ascending
            return -1
          if (nameA > nameB)
            return 1
          return 0 //default return value (no sorting)
        })
        this.languages = languages;
        this.maritals = maritals;
        this.degrees = degrees;
        this.incomes = incomes;
        this.timeZoneId = timeZoneId;
        this.timeZoneList = timeZoneList;
        this.studyFields = study;
        this.workingLocation = locations;
        this.countries = country;
        for (let l of country) {
          let eachCountry = {
            id: Number(l.id + ""),
            businessName: l.name,
          }
          this.allCountries.push(eachCountry);
        }
        if (action == 'add') {
          this.showAddUser();
        } else {
          this.showEditUser(savedData, action);
        }
      },
    });
  }

  checkSubscriptionLimit() {
    this.organizationSubscriptionService
      .getFeatureSubscriptionInfo(FeatureSubscriptionInfoEnums.User)
      .pipe(takeUntil(this.ngUnsubscribe)).subscribe({
        next: (response) => {
          this.subscriptionLimit = response;
        }
      })
  }

  get subscriptionLimitReached() {
    return (!this.tempUser.id
      && !this.isDisabledUserEdit
      && this.subscriptionLimit?.allowedLicence
      && this.subscriptionLimit?.allowedLicence <= this.subscriptionLimit?.consumedLicense)
  }

  getUserWorkingLocation() {
    this.appMainService.isShowSpinner('getUserWorkingLocation');
    this.jobTypeService.getUserWorkingLocation()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe({
        next: (response) => {
          this.workingLocation = response;
          this.appMainService.isHideSpinner('getUserWorkingLocation');
        },
        error: ((error) => {
          this.appMainService.isHideSpinner('getUserWorkingLocation');
          this.messageService.add({ severity: 'error', summary: 'Error', detail: error?.error?.Message ? error?.error?.Message : 'Job Types are not loaded..' });
        }),
        complete: (() => {
        })
      });
  }

  getJobTypes(): void {
    this.appMainService.isShowSpinner('getJobTypes');
    this.jobTypeService.getJobTypes()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe({
        next: (response) => {
          this.jobTypes = response;
          this.appMainService.isHideSpinner('getJobTypes');
        },
        error: ((error) => {
          this.appMainService.isHideSpinner('getJobTypes');
          this.messageService.add({ severity: 'error', summary: 'Error', detail: error?.error?.Message ? error?.error?.Message : 'Job Types are not loaded..' });
        }),
        complete: (() => {
        })
      });
  }

  getUserConfiguration() {
    this.appMainService.isShowSpinner('UserConfig')
    this.service.getConfigurationByModuleName('User').subscribe(
      configs => {
        this.loadTemplateData(configs);
      },
      err => {
        this.appMainService.isHideSpinner('UserConfig')
      }
    )
  }

  loadTemplateData(configs) {
    this.appMainService.isHideSpinner('UserConfig')
    this.emailConfig = configs.find(s => s.name == ObjectNames.CONTACTS_EMAIL_TYPES && s.typeId == 93);
    this.emailtype = this.emailConfig ? JSON.parse(this.emailConfig.configurationDetails[0].configJSONValue) : [];

    this.phoneConfig = configs.find(s => s.name == ObjectNames.CONTACTS_PHONE_TYPES && s.typeId == 94);
    this.phonetype = this.phoneConfig ? JSON.parse(this.phoneConfig.configurationDetails[0].configJSONValue) : [];

    this.socialConfig = configs.find(s => s.name == ObjectNames.CONTACTS_SOCIAL_TYPES && s.typeId == 95);
    this.socials = this.socialConfig ? JSON.parse(this.socialConfig.configurationDetails[0].configJSONValue) : [];

    // user
    this.userTemplateConfig = configs.find(s => s.name == ObjectNames.USER_TEMPLATE && s.typeId == 99);
    ////console.log('userTemplateConfig', this.userTemplateConfig)
    if (this.userTemplateConfig) {
      this.allUserTemplates = JSON.parse(this.userTemplateConfig.configurationDetails[0].configJSONValue);
      this.selectedUserLabels_info = this.allUserTemplates[0].labels_info;
      this.selectedUserLabels_address = this.allUserTemplates[0].labels_address;
      this.selectedUserLabels_other_info = this.allUserTemplates[0].other_info;
    }
    this.selectedUserLabels_info = this.allUserTemplates.length ? this.allUserTemplates[0].labels_info : [];
    this.selectedUserLabels_address = this.allUserTemplates.length ? this.allUserTemplates[0].labels_address : [];
    this.selectedUserLabels_other_info = this.allUserTemplates.length ? this.allUserTemplates[0].other_info : [];
  }


  getTranslatedData() {
    this.translocoService.selectTranslate('Configuration.User.User').subscribe((data) => {
      this.userTranslate.User = data;
    });
    this.translocoService.selectTranslate('Configuration.User.Group').subscribe((data) => {
      this.userTranslate.Group = data;
    });
    this.translocoService.selectTranslate('Configuration.User.Field_Data').subscribe((data) => {
      this.userTranslate.FieldData = data;
    });
    this.translocoService.selectTranslate('Configuration.User.Add_User').subscribe((data) => {
      this.userTranslate.AddUserHeading = data;
    });
    this.translocoService.selectTranslate('Configuration.User.Show_Less').subscribe((data) => {
      this.userTranslate.ShowLess = data;
    });
    this.translocoService.selectTranslate('Configuration.User.Show_More').subscribe((data) => {
      this.userTranslate.ShowMore = data;
    });
    this.translocoService.selectTranslate('Configuration.User.View_User_Group').subscribe((data) => {
      this.userTranslate.ViewUserGroupHeading = data;
    });
    this.translocoService.selectTranslate('Configuration.User.Add_User_Group').subscribe((data) => {
      this.userTranslate.AddUserGroupHeading = data;
    });
    this.translocoService.selectTranslate('Configuration.User.Edit_User_Group').subscribe((data) => {
      this.userTranslate.EditUserGroupHeading = data;
    });
    this.translocoService.selectTranslate('Configuration.User.Copy_User_Group').subscribe((data) => {
      this.userTranslate.CopyUserGroupHeading = data;
    });
    this.translocoService.selectTranslate('Configuration.User.Add_Field_Data').subscribe((data) => {
      this.userTranslate.AddFieldDataHeading = data;
    });
    this.translocoService.selectTranslate('Configuration.User.View_User').subscribe((data) => {
      this.userTranslate.ViewUserHeading = data;
    });
    this.translocoService.selectTranslate('Configuration.User.Edit_User').subscribe((data) => {
      this.userTranslate.EditUserHeading = data;
    });
    this.translocoService.selectTranslate('Configuration.User.Copy_User').subscribe((data) => {
      this.userTranslate.CopyUserHeading = data;
    });
    this.translocoService.selectTranslate('Configuration.User.Delete_Confirmation_Header').subscribe((data) => {
      this.userTranslate.DeleteConfirmationHeader = data;
    });
    this.translocoService.selectTranslate('Configuration.User.User_Delete_Confirmation_MSG').subscribe((data) => {
      this.userTranslate.UserDeleteConfirmationMsg = data;
    });
    this.translocoService.selectTranslate('Configuration.User.User_Group_Delete_Confirmation_MSG').subscribe((data) => {
      this.userTranslate.UserGroupDeleteConfirmationMsg = data;
    });
    this.translocoService.selectTranslate('Configuration.User.Gender_Delete_Confirmation_MSG').subscribe((data) => {
      this.userTranslate.GenderDeleteConfirmationMsg = data;
    });
    this.translocoService.selectTranslate('Configuration.User.Language_Delete_confirmation_MSG').subscribe((data) => {
      this.userTranslate.LanguageDeleteConfirmationMsg = data;
    });
    this.translocoService.selectTranslate('Configuration.User.Relationship_Status_Delete_Confirmation_MSG').subscribe((data) => {
      this.userTranslate.RelationshipStatusDeleteConfirmationMsg = data;
    });
    this.translocoService.selectTranslate('Configuration.User.Marital_Status_Delete_Confirmation_MSG').subscribe((data) => {
      this.userTranslate.MaritalStatusDeleteConfirmationMsg = data;
    });
    this.translocoService.selectTranslate('Configuration.User.Annual_Income_Delete_Confirmation_MSG').subscribe((data) => {
      this.userTranslate.AnnualIncomeDeleteConfirmationMsg = data;
    });
    this.translocoService.selectTranslate('Configuration.User.Degree_Delete_Confirmation_MSG').subscribe((data) => {
      this.userTranslate.DegreeDeleteConfirmationMsg = data;
    });
    this.translocoService.selectTranslate('Configuration.User.Email_Type_Delete_Confirmation_MSG').subscribe((data) => {
      this.userTranslate.EmailTyeDeleteConfirmationMsg = data;
    });
    this.translocoService.selectTranslate('Configuration.User.Phone_Type_Delete_Confirmation_MSG').subscribe((data) => {
      this.userTranslate.PhoneTypeDeleteConfirmationMsg = data;
    });
    this.translocoService.selectTranslate('Configuration.User.Social_Type_Delete_Confirmation_MSG').subscribe((data) => {
      this.userTranslate.SocialTypeDeleteConfirmationMsg = data;
    });
    this.translocoService.selectTranslate('Configuration.User.Edit_Field_Data').subscribe((data) => {
      this.userTranslate.EditFieldDataHeading = data;
    });
  }

  getUsersList() {
    this.appMainService.isShowSpinner('getUsersList');
    this.service.getOrgUsersList()
      .subscribe({
        next: (resp) => {
          this.allUsers = resp.sort((a, b) => a.name.toLowerCase().localeCompare(b?.name.toLowerCase()));
          this.filterUsers();
          this.appMainService.isHideSpinner('getUsersList');
        },
        error: () => {
          this.appMainService.isHideSpinner('getUsersList');
        }
      });
  }

  getRoleWiseUserList() {
    this.appMainService.isShowSpinner('getRoleWiseUserList');
    this.service.getRoleWiseUsers()
      .subscribe(
        resp => {
          this.roleWiseUsers = resp;
          //console.log('roleWiseUsers', resp)
          this.appMainService.isHideSpinner('getRoleWiseUserList');
        },
        err => {
          this.appMainService.isHideSpinner('getRoleWiseUserList');
        },
      );
  }

  getUserGroupList() {
    this.service.getOrgUserGroups(this.app.user.organizationId)
      .pipe(
        map(res => {
          return res.map(group => {
            let groupOwnersList: any[] = [];
            group.groupOwners.map(groupOwner => {
              groupOwnersList.push(groupOwner.name);
            })
            group.ownerList = groupOwnersList.join(', ');
            if (group.parentGroup) {
              delete group.parentGroup
            }
            return group;
          })
        })
      ).subscribe(resp => {
        this.allUserGroup = [...resp];
        this.allUserGroup.sort(function (a, b) {
          var nameA = a.group.name.toLowerCase(), nameB = b.group.name.toLowerCase()
          if (nameA < nameB) //sort string ascending
            return -1
          if (nameA > nameB)
            return 1
          return 0 //default return value (no sorting)
        })
        ////console.log('updated this.allUserGroup', this.allUserGroup)
      });
  }

  getRolesList() {
    this.service.getOrgRoles(this.app.user.organizationId)
      .pipe(
        map(res => {
          return res.filter(userObj => userObj.statusId == 1)
        })
      )
      .subscribe(resp => {
        this.allRoles = [...resp];
        this.allRoles.sort(function (a, b) {
          var nameA = a.role.name.toLowerCase(), nameB = b.role.name.toLowerCase()
          if (nameA < nameB) //sort string ascending
            return -1
          if (nameA > nameB)
            return 1
          return 0 //default return value (no sorting)
        })
        ////console.log('allRoles', this.allRoles)
      });
  }


  removeProfileImage(index: number) {
    this.tempUser.profileImage.statusId = Status.Deleted;
    this.tempUser.profileImage.content = null;
    this.tempUser.profileImageId = 0;
  }

  uploadProfilePic(files: File[]) {
    this.appMainService.isShowSpinner('upload');
    if (typeof Worker !== undefined) {
      for (let file of files) {
        let errors = validateFiles(file, 4, this.allowedExtensions);
        if (errors.length > 0) {
          for (let error of errors) {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: error.fileName + ": " + error.error });
          }
          this.appMainService.isHideSpinner('upload');
        } else {
          uploadFiles(file, ({ name, content, size, extension }) => {
            ////console.log('resp', name, content, size, extension)
            this.userProfileAttachment = {
              "id": 0,
              "createdSource": this.app.user.userIP,
              "updatedSource": this.app.user.userIP,
              "createdBy": this.app.user.userId,
              "updatedBy": this.app.user.userId,
              "createdDate": new Date(),
              "updatedDate": new Date(),
              "name": name,
              "guidName": "",
              "location": "",
              "content": content,
              "extension": extension,
              "mediaType": "",
              "sizeInBytes": size,
              "description": "",
              "statusId": Status.Active,
              "isValid": true,
              "validFromDate": null,
              "validToDate": null
            }
            this.tempUser.profileImage = this.userProfileAttachment;
            this.tempUser.profileImageId = 0;
            this.appMainService.isHideSpinner('upload');
          });
        }
      }
    } else {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: "Please update the browser. Web Workers are not supported in the older versions of this browser." });
    }
  }

  deleteUser(i, userObj) {
    this.confirmationService.confirm({
      message: this.userTranslate.UserDeleteConfirmationMsg,
      header: this.userTranslate.DeleteConfirmationHeader,
      icon: 'pi pi-info-circle',
      accept: () => {

        this.service.deleteUser(userObj.id).subscribe(
          resp => {
            let tempusers: any[] = [];
            for (let u of this.allUsers) {
              if (u.id != userObj.id) {
                tempusers.push(u);
              }
            }
            this.allUsers = tempusers;
            this.service.notifyUserAdded();
            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Deleted Successfully...' });
          },
          err => {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error occurred while deleting data...' });
          });
      },
      reject: () => {
      }
    });
  }

  deleteUserGroup(id, index) {
    this.confirmationService.confirm({
      message: this.userTranslate.UserGroupDeleteConfirmationMsg,
      header: this.userTranslate.DeleteConfirmationHeader,
      icon: 'pi pi-info-circle',
      accept: () => {

        this.allUserGroup.splice(index, 1);
        this.allUserGroup = [...this.allUserGroup];
        this.service.deleteUserGroup(id).subscribe(
          resp => {
            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Deleted Successfully...' });
          },
          err => {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error occurred while deleting data...' });
          });
      },
      reject: () => {
      }
    });
  }

  getUserCustomPermission(typeofpermission) {

    let permissionDetails = this.alluserPermissionCustom ? (this.alluserPermissionCustom.find(obj => obj.permissionName == typeofpermission && obj.statusId == 1) ? true : false) : false;
    return permissionDetails;
  }

  setUserPermissions(user) {
    this.displayPermission = true;
    this.selectedUser = user;
    this.appMainService.isShowSpinner('loadUserPermission');
    this.service.getUserPermissions(user.id).subscribe(
      resp => {
        let allViewEnabled = true;
        let allCreateEnabled = true;
        let allEditEnabled = true;
        let allDeleteEnabled = true;
        let allExportEnabled = true;

        this.userPermisions = resp.map(obj => {
          const permissionData = obj.permissions;
          permissionData.sort((a, b) => a.permissionId > b.permissionId ? 1 : -1)
          obj.permissions = permissionData;
          return obj;
        });
        this.userPermisions.map(object => {
          if (object.permissions[0].statusId) {
            if (object.permissions[0].statusId !== 1) {
              allViewEnabled = false;
            }
            if (object.permissions[1].statusId !== 1) {
              allCreateEnabled = false;
            }
            if (object.permissions[2].statusId !== 1) {
              allEditEnabled = false;
            }
            if (object.permissions[3].statusId !== 1) {
              allDeleteEnabled = false;
            }
            if (object.permissions[4].statusId !== 1) {
              allExportEnabled = false;
            }
          }

          object.permissions.map(permissionObj => {
            permissionObj.checked = permissionObj.statusId == 1;
          })
        });
        this.allViewPermissions = allViewEnabled;
        this.allCreatePermissions = allCreateEnabled;
        this.allEditPermissions = allEditEnabled;
        this.allDeletePermissions = allDeleteEnabled;
        this.allExportPermissions = allExportEnabled;
        this.updatedUserPermissions = [];
        this.appMainService.isHideSpinner('loadUserPermission');
      },
      err => {
        this.appMainService.isHideSpinner('loadUserPermission');
      }
    )
    this.getReportConfigData(user.id);
    //this.buildConfigMenu();
  }

  openOrgChart(c: any) {
    this.orgData = [];
    this.displayOpenOrgChart = true;
    this.appMainService.isShowSpinner('LoadOrgChat');
    this.service.getUserOrgChartData(c?.id).subscribe({
      next: (resp) => {
        this.appMainService.isHideSpinner('LoadOrgChat');
        this.getFormattedChart(resp);
      },
      error: (err) => {
        this.appMainService.isHideSpinner('LoadOrgChat');
      }
    });

  }

  getNode(resp) {
    const data = {
      label: resp?.role,
      type: 'person',
      styleClass: 'p-person',
      expanded: true,
      data: { name: resp?.name, 'avatar': resp?.profileImage && resp?.profileImage.location ? resp?.profileImage.location : null },
      children: [] as any[],
    };
    const childrens: any[] = [];
    if (resp?.childUsers && resp?.childUsers?.length) {
      resp.childUsers.map(obj => {
        childrens.push(this.getNode(obj))
      })
    }
    data.children = childrens;
    return data;
  }


  getFormattedChart(resp) {
    if (resp) {
      this.orgData = [this.getNode(resp)]
    }
  }

  setAllChildPermissions(permissionIndex) {
    let newPermission;
    switch (permissionIndex) {
      case 0: newPermission = this.allViewPermissions; break;
      case 1: newPermission = this.allCreatePermissions; break;
      case 2: newPermission = this.allEditPermissions; break;
      case 3: newPermission = this.allDeletePermissions; break;
      case 4: newPermission = this.allExportPermissions; break;


    }
    this.userPermisions.map(permissionObj => {
      if (permissionObj.permissions[permissionIndex].checked != newPermission) {
        permissionObj.permissions[permissionIndex].checked = newPermission;
        this.permissionChanged(permissionObj.permissions[permissionIndex], permissionObj.objectId)
      }
    })
  }

  updatedUserPermissions: any[] = [];
  permissionChanged(obj, objectId) {
    const newPermissionObj = {
      "id": 0,
      "createdSource": this.app.user.userIP,
      "updatedSource": this.app.user.userIP,
      "createdBy": this.app.user.userId,
      "updatedBy": this.app.user.userId,
      "createdDate": new Date(),
      "updatedDate": new Date(),
      "userId": this.selectedUser.id,
      "permissionId": obj.permissionId,
      "objectId": objectId,
      "configurationId": 0,
      "statusId": obj.checked == true ? 1 : 2,
      "isValid": true,
      "validFromDate": new Date(),
      "validToDate": new Date(new Date().setFullYear(new Date().getFullYear() + 10)),
    }
    const existingPermissionIndex = this.updatedUserPermissions.findIndex(permissionObj => permissionObj.objectId == objectId && permissionObj.permissionId == obj.permissionId)

    if (existingPermissionIndex >= 0) {
      this.updatedUserPermissions.splice(existingPermissionIndex, 1)
    } else {
      this.updatedUserPermissions.push(newPermissionObj);
    }
    this.syncHeaderCheckbox(obj.permissionId);
  }

  syncHeaderCheckbox(permissionId) {
    const allPermissionCount = this.userPermisions.length;
    const activePermissionCounts = this.updatedUserPermissions.filter(obj => obj.permissionId == permissionId && obj.statusId == 1);
    const inactivePermissionCounts = this.updatedUserPermissions.filter(obj => obj.permissionId == permissionId && obj.statusId == 2);
    let newStatus = (activePermissionCounts.length == allPermissionCount && inactivePermissionCounts.length == 0) ? true : false;

    // this condition is to handle initial state where all selected or unselected earlier
    if (activePermissionCounts.length == 0 && inactivePermissionCounts.length == 0) {
      const initialActivePermissions = this.userPermisions.filter(obj => obj.permissions[permissionId - 1].statusId == 1)
      if (initialActivePermissions.length == allPermissionCount) {
        newStatus = true;
      } else {
        newStatus = false;
      }
    }

    switch (permissionId) {
      case 1: this.allViewPermissions = newStatus; break;
      case 2: this.allCreatePermissions = newStatus; break;
      case 3: this.allEditPermissions = newStatus; break;
      case 4: this.allDeletePermissions = newStatus; break;
      case 5: this.allExportPermissions = newStatus; break;
    }
  }

  assignUserPermission() {

    if (this.updatedUserPermissions.length) {
      this.appMainService.isShowSpinner('assignUserPermission');
      this.service.assignUserPermissions(this.updatedUserPermissions).subscribe(
        resp => {
          this.updatedUserPermissions = [];
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Role permission updated Successfully...' });
        },
        err => {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error occurred while updating role permissions...' })
        },
        () => this.appMainService.isHideSpinner('assignUserPermission')
      );
    } else {
      this.messageService.add({ severity: 'warn', summary: 'Warning', detail: 'Permission(s) not updated!!!' });
    }
  }

  CheckAllChild(event, permissionName) {
    if (event.parentobjectId > 0) {

      this.reportPermissionData.forEach(Element => {
        if (Element.data.objectId == event.parentobjectId) {
          if (event.view == true)
            Element.data.view = true;
          // else
          //   Element.data.view = true;
          if (event.export == true)
            Element.data.export = true;
          // else
          //   Element.data.export = true;
        }
      });

    }
    else {
      this.reportPermissionData.forEach(Element => {
        if (Element.data.objectId == event.objectId) {

          Element.children.forEach(cElement => {

            if (cElement.data.parentobjectId == event.objectId) {
              if (permissionName == 'view') {
                if (Element.data.view == true)
                  cElement.data.view = true;
                else
                  cElement.data.view = false;
              }
              if (permissionName == 'export') {
                if (Element.data.export == true)
                  cElement.data.export = true;
                else
                  cElement.data.export = false;
              }
            }

          })
        }
      });

    }
  }

  assignReportUserPermission() {
    ////console.log(this.reportPermissionData);
    const updatedPermissions: any[] = [];
    this.reportPermissionData.forEach(Element => {

      updatedPermissions.push({
        "id": 0,
        "createdSource": this.app.user.userIP,
        "updatedSource": this.app.user.userIP,
        "createdBy": this.app.user.userId,
        "updatedBy": this.app.user.userId,
        "createdDate": new Date(),
        "updatedDate": new Date(),
        "userId": this.selectedUser.id,
        "permissionId": Element.data.viewPermissionId,
        "objectId": Element.data.objectId,
        "configurationId": 0,
        "statusId": Element.data.view == true ? 1 : 2,
        "isValid": true,
        "validFromDate": new Date(),
        "validToDate": new Date(new Date().setFullYear(new Date().getFullYear() + 10)),
      })
      updatedPermissions.push({
        "id": 0,
        "createdSource": this.app.user.userIP,
        "updatedSource": this.app.user.userIP,
        "createdBy": this.app.user.userId,
        "updatedBy": this.app.user.userId,
        "createdDate": new Date(),
        "updatedDate": new Date(),
        "userId": this.selectedUser.id,
        "permissionId": Element.data.exportPermissionId,
        "objectId": Element.data.objectId,
        "configurationId": 0,
        "statusId": Element.data.export == true ? 1 : 2,
        "isValid": true,
        "validFromDate": new Date(),
        "validToDate": new Date(new Date().setFullYear(new Date().getFullYear() + 10)),
      })

      Element.children.forEach(element => {

        updatedPermissions.push({
          "id": 0,
          "createdSource": this.app.user.userIP,
          "updatedSource": this.app.user.userIP,
          "createdBy": this.app.user.userId,
          "updatedBy": this.app.user.userId,
          "createdDate": new Date(),
          "updatedDate": new Date(),
          "userId": this.selectedUser.id,
          "permissionId": element.data.exportPermissionId,
          "objectId": element.data.objectId,
          "configurationId": 0,
          "statusId": element.data.export == true ? 1 : 2,
          "isValid": true,
          "validFromDate": new Date(),
          "validToDate": new Date(new Date().setFullYear(new Date().getFullYear() + 10)),
        })
        updatedPermissions.push({
          "id": 0,
          "createdSource": this.app.user.userIP,
          "updatedSource": this.app.user.userIP,
          "createdBy": this.app.user.userId,
          "updatedBy": this.app.user.userId,
          "createdDate": new Date(),
          "updatedDate": new Date(),
          "userId": this.selectedUser.id,
          "permissionId": element.data.viewPermissionId,
          "objectId": element.data.objectId,
          "configurationId": 0,
          "statusId": element.data.view == true ? 1 : 2,
          "isValid": true,
          "validFromDate": new Date(),
          "validToDate": new Date(new Date().setFullYear(new Date().getFullYear() + 10)),
        })
      });
      ////console.log(Element.children)

    })
    ////console.log('updatedPermissions')
    ////console.log(updatedPermissions)
    this.appMainService.isShowSpinner('assignUserPermission');
    this.service.assignUserPermissions(updatedPermissions).subscribe(
      resp => {
        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Role permission updated Successfully...' });
      },
      err => {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error occurred while updating role permissions...' })
      },
      () => this.appMainService.isHideSpinner('assignUserPermission')
    );
  }

  getSelectedUsers(roleUserslist, usersForSelection) {
    let usersList: any[] = [];
    roleUserslist.filter(obj => {
      usersList = usersList.length ? [...usersList, ...obj.users] : [...obj.users]
    });

    const selectectUsers = usersForSelection ? usersList.filter(userObj => usersForSelection.find(reportToUser => reportToUser.subUserId == userObj.id)) : [];
    return selectectUsers;
  }

  getSelectedUsersIds(usersList) {
    const ids: any[] = [];
    if (usersList.length) {
      usersList.filter(user => {
        ids.push(user.subUserId)
      });
    }

    return ids;
  }

  getActiveUsersList(roleWiseUserList) {
    const roleList: any[] = [];
    roleWiseUserList.forEach(role => {
      const roleUsers = role.users.filter(user => (user.statusId == Status.Active));
      if (roleUsers.length) {
        role.users = roleUsers;
        roleList.push(role)
      }
    })
    return roleList;
    //return  roleWiseUserList.filter(obj => obj.users.filter(user=> (user.statusId == Status.Active || addUserIds.length || addUserIds.indexOf(user.id)  >= 0)) )
  }

  showEditUser(user, viewType) {
    this.getChannels();
    this.showAddMore = true;
    this.userForChannelPermission = user;
    this.userFormSubmitted = false;
    this.isDisabledUserEdit = false;
    switch (viewType) {
      case 'view':
        this.addEditUserHeader = this.userTranslate.ViewUserHeading;
        this.isDisabledUserEdit = true;
        break;
      case 'edit':
        this.addEditUserHeader = this.userTranslate.EditUserHeading;
        break;
      case 'copy':
        this.addEditUserHeader = this.userTranslate.CopyUserHeading;
        break;
    }
    this.activeUsers = this.allUsers.filter(obj => obj.statusId == 1);


    const visibleFields = this.selectedUserLabels_address.find(obj => obj.checked == true);
    this.showUserformaddresfields = visibleFields ? true : false;
    const visibleOtherFields = this.selectedUserLabels_other_info.find(obj => obj.checked == true);
    this.showUserformOtherfields = visibleOtherFields ? true : false;
    this.selectedUserLabelsFieldsCount = this.selectedUserLabels_info.filter(obj => obj.checked == true).length;

    this.service.getOrgUserById(user.id).subscribe(resp => {
      let userData;
      this.selectedUserData = resp;
      this.deletedPermissionsTB = [];
      this.permissionsTB = this.selectedUserData?.channelPermission.map((obj) => {
        return {
          userProfileID: obj?.userProfileID,
          channelID: obj?.channelID,
          channelName: obj?.channelName,
          userProfileName: obj?.userProfileName,
          isDefault: obj?.isDefault ?? false,
          isActive: obj?.isActive,
          id: obj?.id,
          userId: obj?.userId
        }
      });
      userData = resp;
      //this.selectedUserRole = resp.role ? this.allRoles.find(roleobj => roleobj.id == userData.roleId) : null;
      //this.selectedRoleHierarchy = resp.role ? this.getSelectedRoleHierarchy() : null;
      if (resp.roleId) {
        this.roleIdTemp = resp.roleId;
        this.getSelectedRoleHierarchy(resp.roleId);
      }
      // else {
      //   this.selectedRoleHierarchy = null;
      // }
      this.selectedJobType = resp.jobTypeId ? this.jobTypes.find(x => x.id == userData.jobTypeId) : null;
      //this.selectedProfile = resp.userProfileId ? this.allProfile.find(x => x.id == userData.userProfileId) : null;
      // if (this.selectedProfile !== null){
      //   this.isProfileSelected = true;
      // }
      // else {
      //   this.isProfileSelected = false;
      // }
      this.selectedGender = resp.gender ? this.genders.find(genderObj => genderObj.name == userData.gender) : null;
      this.selectedDepartment = resp.department ? this.departments.find(departmentsObj => departmentsObj.name == userData.department) : null;
      this.selectedMaritialStatus = resp.userDetail && resp.userDetail.maritalStatusId ? this.maritals.find(maritialStatusObj => maritialStatusObj.id == resp.userDetail.maritalStatusId) : null;
      this.selectedDegree = resp.userDetail && resp.userDetail.degreeId ? this.degrees.find(degreeObj => degreeObj.id == resp.userDetail.degreeId) : null;
      this.selectedFieldOfStudy = resp.userDetail && resp.userDetail.fieldOfStudyId ? this.studyFields.find(fieldOfStudyObj => fieldOfStudyObj.id == resp.userDetail.fieldOfStudyId) : null;
      this.selectedWorkingLocation = resp.locationIds ? this.workingLocation.find(workingLocation => {
        return resp.locationIds.includes(workingLocation.id);
      }) : null;
      this.selectedAnnulIncome = resp.userDetail && resp.userDetail.annualIncomeId ? this.incomes.find(obj => obj.id == resp.userDetail.annualIncomeId) : null;
      //const selectedUsers = this.getSelectedUsersIds(resp.reportToUsers)
      this.activeRoleWiseUsers = this.getActiveUsersList(this.roleWiseUsers);
      this.selectedReportsTo = this.getSelectedUsers(this.roleWiseUsers, resp.reportToUsers); //resp.reportToUsers ? this.allUsers.filter(userObj => resp.reportToUsers.find(reportToUser => reportToUser.subUserId == userObj.id)) : [];
      ////console.log("selectedReportsTo", this.selectedReportsTo)
      this.selectedLanguages = resp.userLanguages ? this.languages.filter(langObj => resp.userLanguages.find(userLang => userLang.language.id == langObj.id)) : [];

      this.addressInput = resp.mainAddress?.streetAddress1;
      this.addressInputForPostal = resp.postalAddress?.streetAddress1;

      this.selectedMCountry = resp.mainAddress && resp.mainAddress.countryId ? this.countries.find(countryObj => countryObj.id == resp.mainAddress.countryId) : null;
      if (resp.mainAddress && resp.mainAddress?.countryId) {
        this.loadCountryStates('main', { id: resp.mainAddress.countryId }, resp.mainAddress.stateId);
      }
      if (resp.mainAddress && resp.mainAddress.stateId) {
        this.loadCountryCities('main', { id: resp.mainAddress.stateId }, resp.mainAddress.cityId)
      }

      if (resp.postalAddress && resp.postalAddress?.countryId) {
        this.loadCountryStates('postal', { id: resp.postalAddress.countryId }, resp.postalAddress.stateId);
      }
      if (resp.postalAddress && resp.postalAddress?.stateId) {
        this.loadCountryCities('postal', { id: resp.postalAddress.stateId }, resp.postalAddress.cityId)
      }
     
      this.selectedPCountry = resp.postalAddress && resp.postalAddress.countryId ? this.countries.find(countryObj => countryObj.id == resp.postalAddress.countryId) : null;
      this.selectedTimeZone = resp.userDetail && resp.userDetail.timezoneId ? this.timeZoneList.find(timezoneObj => timezoneObj.id == resp.userDetail.timezoneId) : this.selectedTimeZone = this.timeZoneList.find(obj => obj.id == this.app.organizationData.timeZone.id);

      this.tempUser = {
        "id": userData && (this.addEditUserHeader == "Edit User" || this.addEditUserHeader == "Modifier l'utilisateur" || this.addEditUserHeader == "编辑用户")
          ? userData.id : 0,
        "createdSource": userData ? userData.createdSource : this.app.user.userIP,
        "updatedSource": this.app.user.userIP,
        "createdBy": userData ? userData.createdBy : this.app.user.userId,
        "updatedBy": this.app.user.userId,
        "createdDate": userData ? new Date(userData.createdDate) : new Date(),
        "updatedDate": new Date(),
        "uniqueId": userData && (this.addEditUserHeader == "Edit User" || this.addEditUserHeader == "Modifier l'utilisateur" || this.addEditUserHeader == "编辑用户")
          ? userData.uniqueId : null,
        "name": userData ? userData.name : '',
        "channelPermission": userData ? userData?.channelPermission : [],
        "description": userData ? userData.description : '',
        "firstName": userData ? userData.firstName : '',
        "middleName": userData ? userData.middleName : '',
        "lastName": userData ? userData.lastName : '',
        "organizationId": userData ? userData.organizationId : this.app.user.organizationId,
        "roleId": userData ? userData.roleId : 0,
        "jobTypeId": userData ? userData.jobTypeId : 0,
        "userProfileId": userData ? userData.userProfileId : 0,
        "emailId": userData ? userData.emailId : "",
        "password": userData ? userData.password : "testpassword",
        "imageId": userData ? userData.imageId : 0,
        "profileImageId": userData && (this.addEditUserHeader == "Edit User" || this.addEditUserHeader == "Modifier l'utilisateur" || this.addEditUserHeader == "编辑用户")
          ? userData.profileImageId : 0,
        "profileImage": {
          "id": userData && userData.profileImage
            && (this.addEditUserHeader == "Edit User" || this.addEditUserHeader == "Modifier l'utilisateur" || this.addEditUserHeader == "编辑用户")
            ? userData.profileImage.id : 0,
          "createdSource": userData ? userData.profileImage && userData.profileImage.createdSource : this.app.user.userIP,
          "updatedSource": this.app.user.userIP,
          "createdBy": userData ? userData.profileImage && userData.profileImage.createdBy : this.app.user.userId,
          "updatedBy": this.app.user.userId,
          "createdDate": userData ? userData.profileImage && new Date(userData.profileImage.createdDate) : new Date(),
          "updatedDate": new Date(),
          "name": userData ? userData.profileImage && userData.profileImage.name : "",
          "guidName": userData ? userData.profileImage && userData.profileImage.guidName : "",
          "location": userData ? userData.profileImage && userData.profileImage.location : "",
          "content": userData ? userData.profileImage && userData.profileImage.downloadLink : "",
          "extension": userData ? userData.profileImage && userData.profileImage.extension : "",
          "mediaType": userData ? userData.profileImage && userData.profileImage.sizeInBytes : "",
          "sizeInBytes": userData ? userData.profileImage && userData.profileImage.sizeInBytes : "",
          "description": userData ? userData.profileImage && userData.profileImage.description : "",
          "statusId": userData ? userData.profileImage && userData.profileImage.statusId : Status.Active,
          "isValid": userData ? userData.profileImage && userData.profileImage.isValid : true,
          "validFromDate": userData ? userData.profileImage && userData.profileImage.validFromDate : null,
          "validToDate": userData ? userData.profileImage && userData.profileImage.validToDate : null,
        },
        "gender": userData ? userData.gender : "",
        "genderId": 0,
        "department": userData ? userData.department : "",
        "seniority": userData ? userData.seniority : 0,
        "parentUserId": userData ? userData.parentUserId : 0,
        "dateOfBirth": userData ? new Date(userData.dateOfBirth) : null,
        // "mainAddressId":  userData && userData.mainAddress && this.addEditUserHeader == "Edit User" ? userData.mainAddress.id : 0,
        "mainAddressId": 0,
        "mainAddress": {
          "id": 0,
          "createdSource": userData && userData.mainAddress ? userData.mainAddress.createdSource : this.app.user.userIP,
          "updatedSource": this.app.user.userIP,
          "createdBy": userData && userData.mainAddress ? userData.mainAddress.createdBy : this.app.user.userId,
          "updatedBy": this.app.user.userId,
          "createdDate": userData && userData.mainAddress ? new Date(userData.mainAddress.createdDate) : new Date(),
          "updatedDate": new Date(),
          "name": "Mainling address",
          "streetAddress1": userData && userData.mainAddress && userData.mainAddress.streetAddress1 ? userData.mainAddress.streetAddress1 : "",
          "streetAddress2": userData && userData.mainAddress && userData.mainAddress.streetAddress2 ? userData.mainAddress.streetAddress2 : "",
          "description": "",
          "latitude": userData && userData.mainAddress ? userData.mainAddress.latitude : 0,
          "longitude": userData && userData.mainAddress ? userData.mainAddress.longitude : 0,
          "cityId": 0,
          "stateId": 0,
          "countryId": 0,
          "zipCode": userData && userData.mainAddress ? userData.mainAddress.zipCode : "",
          "addressTypeId": 38,
          "statusId": Status.Active,
        },
        // "postalAddressId": userData && userData.postalAddress && this.addEditUserHeader == "Edit User" ? userData.postalAddress.id : 0,
        "postalAddressId": 0,
        "postalAddress": {
          "id": 0,
          "createdSource": userData && userData.postalAddress ? userData.postalAddress.createdSource : this.app.user.userIP,
          "updatedSource": this.app.user.userIP,
          "createdBy": userData && userData.postalAddress ? userData.postalAddress.createdBy : this.app.user.userId,
          "updatedBy": this.app.user.userId,
          "createdDate": userData && userData.postalAddress ? new Date(userData.postalAddress.createdDate) : new Date(),
          "updatedDate": new Date(),
          "name": "Postal address",
          "streetAddress1": userData && userData.postalAddress ? userData.postalAddress.streetAddress1 : "",
          "streetAddress2": userData && userData.postalAddress ? userData.postalAddress.streetAddress2 : "",
          "description": "string",
          "latitude": userData && userData.postalAddress ? userData.postalAddress.latitude : 0,
          "postalAddress": userData && userData.postalAddress ? userData.postalAddress.longitude : 0,
          "cityId": 0,
          "stateId": 0,
          "countryId": 0,
          "zipCode": userData && userData.postalAddress ? userData.postalAddress.zipCode : "",
          "addressTypeId": 39,
          "statusId": userData.postalAddress ? userData.postalAddress.statusId : Status.Active,
        },
        "otherAddressId": null,
        "skills": userData.skills ? userData.skills : "",
        "sourceId": userData.sourceId ? userData.sourceId : 0,
        "statusId": userData.statusId ? userData.statusId == 1 : false,
        "categoryId": userData.categoryId ? userData.categoryId : 1,
        "typeId": userData.typeId ? userData.typeId : 7,
        "isValid": true,
        "validFromDate": userData.validFromDate ? new Date(userData.validFromDate) : new Date(),
        "validToDate": userData.validToDate ? new Date(userData.validToDate) : new Date(new Date().setFullYear(new Date().getFullYear() + 10)),
        "userLanguages": userData.userLanguages.length ? userData.userLanguages : [],
        "userPhones": [
          {
            "id": userData.userPhones && userData.userPhones[0]
              && (this.addEditUserHeader == "Edit User" || this.addEditUserHeader == "Modifier l'utilisateur" || this.addEditUserHeader == "编辑用户")
              ? userData.userPhones[0].id : 0,
            "createdSource": userData.userPhones && userData.userPhones[0] ? userData.userPhones[0].createdSource : this.app.user.userIP,
            "updatedSource": this.app.user.userIP,
            "createdBy": userData.userPhones && userData.userPhones[0] ? userData.userPhones[0].createdBy : this.app.user.userId,
            "updatedBy": this.app.user.userId,
            "createdDate": userData.userPhones && userData.userPhones[0] ? new Date(userData.userPhones[0].createdDate) : new Date(),
            "updatedDate": new Date(),
            "userId": userData.userPhones && userData.userPhones[0]
              && (this.addEditUserHeader == "Edit User" || this.addEditUserHeader == "Modifier l'utilisateur" || this.addEditUserHeader == "编辑用户")
              ? userData.userPhones[0].userId
              : (this.addEditUserHeader == "Copy User" || this.addEditUserHeader == "Copier l'utilisateur" || this.addEditUserHeader == "复制用户")
                ? 0 : userData.id,
            "phoneId": userData.userPhones && userData.userPhones[0] ? userData.userPhones[0].phoneId : 0,
            "phone": {
              "id": userData.userPhones && userData.userPhones[0]
                && (this.addEditUserHeader == "Edit User" || this.addEditUserHeader == "Modifier l'utilisateur" || this.addEditUserHeader == "编辑用户")
                ? userData.userPhones[0].phone.id : 0,
              "createdSource": userData.userPhones && userData.userPhones[0] ? userData.userPhones[0].phone.createdSource : 0,
              "updatedSource": this.app.user.userIP,
              "createdBy": userData.userPhones && userData.userPhones[0] ? userData.userPhones[0].phone.createdBy : this.app.user.userId,
              "updatedBy": this.app.user.userId,
              "createdDate": userData && userData.userPhones && userData.userPhones[0] ? new Date(userData.userPhones[0].phone.createdDate) : new Date(),
              "updatedDate": new Date(),
              "number": userData && userData.userPhones && userData.userPhones[0] ? userData.userPhones[0].phone.number : "",
              "extension": userData && userData.userPhones && userData.userPhones[0] ? userData.userPhones[0].phone.extension : "",
              "description": userData && userData.userPhones && userData.userPhones[0] ? userData.userPhones[0].phone.description : "",
              "phoneTypeId": userData && userData.userPhones && userData.userPhones[0] ? userData.userPhones[0].phone.phoneTypeId : 10,
              "statusId": Status.Active,
            },
            "statusId": Status.Active,
          }
        ],
        "userSocialProfiles": [
          {
            "id": userData && userData.userSocialProfiles && userData.userSocialProfiles[0]
              && (this.addEditUserHeader == "Edit User" || this.addEditUserHeader == "Modifier l'utilisateur" || this.addEditUserHeader == "编辑用户")
              ? userData.userSocialProfiles[0].id : 0,
            "createdSource": userData && userData.userSocialProfiles && userData.userSocialProfiles[0] ? userData.userSocialProfiles[0].createdSource : 0,
            "updatedSource": this.app.user.userIP,
            "createdBy": userData && userData.userSocialProfiles && userData.userSocialProfiles[0] ? userData.userSocialProfiles[0].createdBy : 0,
            "updatedBy": this.app.user.userId,
            "createdDate": userData && userData.userSocialProfiles && userData.userSocialProfiles[0] ? new Date(userData.userSocialProfiles[0].createdDate) : new Date(),
            "updatedDate": new Date(),
            "userId": userData && userData.userSocialProfiles && userData.userSocialProfiles[0]
              && (this.addEditUserHeader == "Edit User" || this.addEditUserHeader == "Modifier l'utilisateur" || this.addEditUserHeader == "编辑用户")
              ? userData.userSocialProfiles[0].userId
              : (this.addEditUserHeader == "Copy User" || this.addEditUserHeader == "Copier l'utilisateur" || this.addEditUserHeader == "复制用户")
                ? 0 : userData.id,
            "socialProfileId": userData && userData.userSocialProfiles && userData.userSocialProfiles[0]
              && (this.addEditUserHeader == "Edit User" || this.addEditUserHeader == "Modifier l'utilisateur" || this.addEditUserHeader == "编辑用户")
              ? userData.userSocialProfiles[0].socialProfileId : 0,
            "socialProfile": {
              "name": userData && userData.userSocialProfiles && userData.userSocialProfiles[0] && userData.userSocialProfiles[0] ? userData.userSocialProfiles[0].socialProfile.name : "",
              "socialProfileTypeId": 37, // linkedin profile
              "id": userData && userData.userSocialProfiles && userData.userSocialProfiles[0]
                && (this.addEditUserHeader == "Edit User" || this.addEditUserHeader == "Modifier l'utilisateur" || this.addEditUserHeader == "编辑用户")
                ? userData.userSocialProfiles[0].socialProfile.id : 0,
              "createdSource": userData && userData.userSocialProfiles && userData.userSocialProfiles[0] ? userData.userSocialProfiles[0].socialProfile.createdSource : this.app.user.userIP,
              "updatedSource": this.app.user.userIP,
              "createdBy": userData && userData.userSocialProfiles && userData.userSocialProfiles[0] ? userData.userSocialProfiles[0].socialProfile.createdBy : this.app.user.userId,
              "updatedBy": this.app.user.userId,
              "createdDate": userData && userData.userSocialProfiles && userData.userSocialProfiles[0] ? new Date(userData.userSocialProfiles[0].socialProfile.createdDate) : new Date(),
              "updatedDate": new Date(),
              "description": userData && userData.userSocialProfiles && userData.userSocialProfiles[0] ? userData.userSocialProfiles[0].socialProfile.description : "",
              "statusId": Status.Active
            },
            "statusId": Status.Active
          },
        ],
        "userDetail": {
          "id": userData.userDetail
            && (this.addEditUserHeader == "Edit User" || this.addEditUserHeader == "Modifier l'utilisateur" || this.addEditUserHeader == "编辑用户")
            ? userData.userDetail.id : 0,
          "createdSource": userData.userDetail ? userData.userDetail.createdSource : this.app.user.userIP,
          "updatedSource": this.app.user.userIP,
          "createdBy": userData.userDetail ? userData.userDetail.createdBy : this.app.user.userId,
          "updatedBy": this.app.user.userId,
          "createdDate": userData.userDetail ? new Date(userData.userDetail.createdDate) : new Date(),
          "updatedDate": new Date(),
          "userId": userData.userDetail
            && (this.addEditUserHeader == "Edit User" || this.addEditUserHeader == "Modifier l'utilisateur" || this.addEditUserHeader == "编辑用户")
            ? userData.userDetail.userId
            : ((this.addEditUserHeader == "Edit User" || this.addEditUserHeader == "Modifier l'utilisateur" || this.addEditUserHeader == "编辑用户")
              ? userData.id : 0),
          "joiningDate": userData && userData.userDetail && userData.userDetail.joiningDate ? new Date(userData.userDetail.joiningDate) : null,
          "languageId": userData && userData.userDetail && userData.userDetail.languageId ? userData.userDetail.languageId : 0,
          "maritalStatusId": userData && userData.userDetail && userData.userDetail.maritalStatusId ? userData.userDetail.maritalStatusId : null,
          "annualIncomeId": userData && userData.userDetail && userData.userDetail.annualIncomeId ? userData.userDetail.annualIncomeId : null,
          "degreeId": userData && userData.userDetail && userData.userDetail.degreeId ? userData.userDetail.degreeId : 0,
          "fieldOfStudyId": userData && userData.userDetail && userData.userDetail.fieldOfStudyId ? userData.userDetail.fieldOfStudyId : 0,
          "totalPendingLeaves": userData && userData.userDetail && userData.userDetail.totalPendingLeaves ? userData.userDetail.totalPendingLeaves : 0,
          "lastLeaveUpdatedDate": userData && userData.userDetail && userData.userDetail.lastLeaveUpdatedDate ? new Date(userData.userDetail.lastLeaveUpdatedDate) : new Date(),
          "isEmailNotification": userData && userData.userDetail && userData.userDetail.isEmailNotification ? userData.userDetail.isEmailNotification : true,
          "isSMSNotification": userData && userData.userDetail && userData.userDetail.isSMSNotification ? userData.userDetail.isSMSNotification : true,
          "isMobileAppTrackMe": userData && userData.userDetail && userData.userDetail.isMobileAppTrackMe ? userData.userDetail.isMobileAppTrackMe : true,
          "timezoneId": userData && userData.userDetail && userData.userDetail.timezoneId ? userData.userDetail.timezoneId : true,
          "trackingStartTime": userData && userData.userDetail && userData.userDetail.trackingStartTime ? new Date(userData.userDetail.trackingStartTime) : null,
          "trackingEndTime": userData && userData.userDetail && userData.userDetail.trackingEndTime ? new Date(userData.userDetail.trackingEndTime) : null,
          "isBranchContactPerson": true,
          "statusId": Status.Active
        }
      };

      this.displayAddUser = true;
    });
  }



  showAddUser() {
    this.addressInput = "";
    this.formattedaddress = "";
    this.addressInputForPostal = "";
    this.formattedAddressForPostal = "";
    this.allStates = [];
    this.allCities = [];
    this.allPStates = [];
    this.allPCities = [];
    this.permissionsTB = [];
    this.deletedPermissionsTB = [];
    this.getChannels();
    this.isDisabledUserEdit = false;
    this.clearUserForm();
    //this.selectedReportsTo = this.roleWiseUsers;
    // if (this.app.organizationData) {
    this.selectedTimeZone = this.timeZoneList.find(obj => obj.id == this.timeZoneId)
    // } else {
    //   this.service.getOrganizationById(this.app.user.organizationId).subscribe(
    //     org => {
    //       this.selectedTimeZone = this.timeZoneList.find(obj => obj.id == org.timeZone.id)
    //     },
    //     err => {

    //     })
    // }

    this.activeUsers = this.allUsers.filter(obj => obj.statusId == 1);
    this.userFormSubmitted = false;
    this.displayAddUser = true;
    this.addEditUserHeader = this.userTranslate.AddUserHeading;
    this.tempUser = {
      "id": 0,
      "createdSource": this.app.user.userIP,
      "updatedSource": this.app.user.userIP,
      "createdBy": this.app.user.userId,
      "updatedBy": this.app.user.userId,
      "createdDate": new Date(),
      "updatedDate": new Date(),
      "name": '',
      "channelPermission": [],
      "description": '',
      "firstName": '',
      "middleName": '',
      "lastName": "",
      "organizationId": this.app.user.organizationId,
      "roleId": 0,
      "jobTypeId": 0,
      "userProfileId": 0,
      "emailId": "",
      "password": "testpassword",
      "imageId": 0,
      "profileImageId": 0,
      "profileImage": {
        "id": 0,
        "createdSource": this.app.user.userIP,
        "updatedSource": this.app.user.userIP,
        "createdBy": this.app.user.userId,
        "updatedBy": this.app.user.userId,
        "createdDate": new Date(),
        "updatedDate": new Date(),
        "name": "",
        "guidName": "",
        "location": "",
        "content": "",
        "extension": "",
        "mediaType": "",
        "sizeInBytes": "",
        "description": "",
        "statusId": Status.Active,
        "isValid": true,
        "validFromDate": new Date(),
        "validToDate": new Date(new Date().setFullYear(new Date().getFullYear() + 10)),
      },
      "gender": "",
      "department": "",
      "seniority": "",
      "parentUserId": 0,
      "dateOfBirth": null,
      "mainAddressId": 0,
      "mainAddress": {
        "id": 0,
        "createdSource": this.app.user.userIP,
        "updatedSource": this.app.user.userIP,
        "createdBy": this.app.user.userId,
        "updatedBy": this.app.user.userId,
        "createdDate": new Date(),
        "updatedDate": new Date(),
        "name": "Mainling address",
        "streetAddress1": this.formattedaddress,
        "streetAddress2": "",
        "description": "",
        "latitude": 0,
        "longitude": 0,
        "cityId": 0,
        "stateId": 0,
        "countryId": 0,
        "zipCode": "",
        "addressTypeId": 38,
        "statusId": Status.Active,
      },
      "mailAddressId": 0,
      "postalAddressId": 0,
      "postalAddress": {
        "id": 0,
        "createdSource": this.app.user.userIP,
        "updatedSource": this.app.user.userIP,
        "createdBy": this.app.user.userId,
        "updatedBy": this.app.user.userId,
        "createdDate": new Date(),
        "updatedDate": new Date(),
        "name": "",
        "streetAddress1": this.formattedAddressForPostal,
        "streetAddress2": "",
        "description": "",
        "latitude": 0,
        "longitude": 0,
        "cityId": 0,
        "stateId": 0,
        "countryId": 0,
        "zipCode": "",
        "addressTypeId": 39,
        "statusId": Status.Active,
      },
      "otherAddressId": 0,
      "skills": "",
      "sourceId": 0,
      "categoryId": 0,
      "typeId": 0,
      "statusId": Status.Active,
      "isValid": true,
      "validFromDate": new Date(),
      "validToDate": new Date(new Date().setFullYear(new Date().getFullYear() + 10)),
      "userLanguages": [],
      "userPhones": [
        {
          "id": 0,
          "createdSource": this.app.user.userIP,
          "updatedSource": this.app.user.userIP,
          "createdBy": this.app.user.userId,
          "updatedBy": this.app.user.userId,
          "createdDate": new Date(),
          "updatedDate": new Date(),
          "userId": 0,
          "phoneId": 0,
          "phone": {
            "id": 0,
            "createdSource": this.app.user.userIP,
            "updatedSource": this.app.user.userIP,
            "createdBy": this.app.user.userId,
            "updatedBy": this.app.user.userId,
            "createdDate": new Date(),
            "updatedDate": new Date(),
            "number": "",
            "extension": "",
            "description": "",
            "phoneTypeId": 10,
            "statusId": Status.Active,
          },
          "statusId": Status.Active,
        }
      ],
      "userSocialProfiles": [
        {
          "id": 0,
          "createdSource": this.app.user.userIP,
          "updatedSource": this.app.user.userIP,
          "createdBy": this.app.user.userId,
          "updatedBy": this.app.user.userId,
          "createdDate": new Date(),
          "updatedDate": new Date(),
          "userId": this.app.user.userId,
          "socialProfileId": 0,
          "socialProfile": {
            "name": "",
            "socialProfileTypeId": 37, // linkedin profile
            "id": 0,
            "createdSource": this.app.user.userIP,
            "updatedSource": this.app.user.userIP,
            "createdBy": this.app.user.userId,
            "updatedBy": this.app.user.userId,
            "createdDate": new Date(),
            "updatedDate": new Date(),
            "description": "",
            "statusId": Status.Active
          },
          "statusId": Status.Active
        }
      ],
      "userDetail": {
        "id": 0,
        "createdSource": this.app.user.userIP,
        "updatedSource": this.app.user.userIP,
        "createdBy": this.app.user.userId,
        "updatedBy": this.app.user.userId,
        "createdDate": new Date(),
        "updatedDate": new Date(),
        "userId": 0,
        "joiningDate": null,
        "languageId": 0,
        "maritalStatusId": 0,
        "annualIncomeId": 0,
        "degreeId": 0,
        "fieldOfStudyId": 0,
        "totalPendingLeaves": 0,
        "lastLeaveUpdatedDate": new Date(),
        "isEmailNotification": true,
        "isSMSNotification": true,
        "isMobileAppTrackMe": true,
        "timezoneId": 0,
        "trackingStartTime": null,
        "trackingEndTime": null,
        "isBranchContactPerson": true,
        "statusId": Status.Active
      }
    };
    const visibleFields = this.selectedUserLabels_address.find(obj => obj.checked == true);
    this.showUserformaddresfields = visibleFields ? true : false;
    const visibleOtherFields = this.selectedUserLabels_other_info.find(obj => obj.checked == true);
    this.showUserformOtherfields = visibleOtherFields ? true : false;
    this.selectedUserLabelsFieldsCount = this.selectedUserLabels_info.filter(obj => obj.checked == true).length;
    let activeRoleWiseUsers = JSON.stringify(this.getActiveUsersList(this.roleWiseUsers));
    this.activeRoleWiseUsers = JSON.parse(activeRoleWiseUsers);
    ////console.log("this.activeRoleWiseUsers", this.activeRoleWiseUsers);
    this.selectedLanguages = [];
    this.showAddMore = false;
    this.selectedUserRole = null;

    //set default channel permission
    if (this.systemDefaultChannelPermission) {
      this.permissionsTB = [
        {
          channelName: this.systemDefaultChannelPermission.channelName,
          channelID: this.systemDefaultChannelPermission.channelID,
          userProfileID: this.systemDefaultChannelPermission.userProfileID,
          userProfileName: this.systemDefaultChannelPermission.userProfileName,
          isDefault: this.systemDefaultChannelPermission.isDefault,
          isActive: this.systemDefaultChannelPermission.isActive,
          statusId: this.systemDefaultChannelPermission.statusId,
          userId: 0,
          id: 0
        }
      ]
    }


    ////console.log('this.tempUser', this.tempUser)
  }


  clearUserForm() {
    this.selectedUserRole = null;
    this.selectedRoleHierarchy = null;
    this.selectedGender = {};
    this.selectedDepartment = {};
    this.selectedLanguages = {};
    this.selectedMaritialStatus = {};
    this.selectedDegree = {};
    this.selectedAnnulIncome = {};
    this.selectedFieldOfStudy = {};
    this.selectedReportsTo = [];
    this.selectedAssistant = {};
    this.selectedMCountry = null;
    this.selectedMState = null;
    this.selectedMCity = null;
    this.selectedPCountry = null;
    this.selectedPState = null;
    this.selectedPCity = null;
    this.selectedTimeZone = {};
    this.selectedUserData = null;
    this.selectedJobType = null;
    this.selectedProfile = null;
    this.isProfileSelected = false;
    this.selectedWorkingLocation = [];
  }

  getYearRange() {
    return `${new Date().getFullYear() - 100}: ${new Date().getFullYear()} `;
  }


  userFormSubmitted = false;
  saveUser() {
    if (this.selectedWorkingLocation?.length === 0 || undefined) {
      this.showAddMore = true;
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Select Working Location' });
    } else {
      this.userFormSubmitted = true;
      if (this.addEditUserForm.form.valid) {
        const addUserData = { ...this.tempUser };
        // if (this.addEditUserHeader == 'Add User'){
        //   addUserData.channelPermission = this.permissionsTB.map((obj) => {
        //     return {
        //       channelID: obj?.channelID,
        //       isActive: obj?.isActive,
        //       isDefault: obj?.isDefault,
        //       userProfileID: obj?.userProfileID
        //     }
        //   })
        // }

        const allPermissions = [...this.permissionsTB, ...this.deletedPermissionsTB];
        addUserData.channelPermission = allPermissions.map((obj) => {
          return {
            channelID: obj?.channelID,
            isActive: obj?.isActive,
            isDefault: obj?.isDefault,
            userProfileID: obj?.userProfileID,
            id: obj?.id ? obj?.id : 0,
            statusId: obj?.statusId ? obj?.statusId : 1
          }
        });


        addUserData.statusId = addUserData.statusId == 1 ? 1 : 2;
        //addUserData.roleId = this.selectedUserRole ? this.selectedUserRole.id : null;
        addUserData.roleId = this.selectedRoleHierarchy ? this.selectedRoleHierarchy.id : 0;
        addUserData.jobTypeId = this.selectedJobType ? this.selectedJobType.id : 0;
        //addUserData.userProfileId = this.selectedProfile ? this.selectedProfile?.id : 0;
        addUserData.gender = this.selectedGender ? this.selectedGender.name : "";
        addUserData.department = this.selectedDepartment ? this.selectedDepartment.name : "";
        addUserData.userDetail.maritalStatusId = this.selectedMaritialStatus ? this.selectedMaritialStatus.id : null;
        addUserData.userDetail.degreeId = this.selectedDegree ? this.selectedDegree.id : 0
        addUserData.userDetail.fieldOfStudyId = this.selectedFieldOfStudy ? this.selectedFieldOfStudy.id : 0;
        addUserData.locationIds = this.selectedWorkingLocation ? [this.selectedWorkingLocation.id] : [];
        addUserData.userDetail.annualIncomeId = this.selectedAnnulIncome ? this.selectedAnnulIncome.id : 0;
        // addUserData.parentUserId = this.selectedReportsTo.length ? this.selectedReportsTo : null;
        addUserData.reportToUsers = [];
        if (this.selectedReportsTo.length) {
          this.selectedReportsTo.map(reportToUser => {
            const existingUser = this.selectedUserData && this.selectedUserData.reportToUsers ? this.selectedUserData.reportToUsers.find(user => user.id == reportToUser.id) : null
            addUserData.reportToUsers.push({
              "id": existingUser ? existingUser.id : 0,
              "createdSource": this.app.user.userIP,
              "updatedSource": this.app.user.userIP,
              "createdBy": existingUser ? existingUser.createdBy : this.app.user.userId,
              "updatedBy": this.app.user.userId,
              "createdDate": existingUser ? existingUser.createdDate : new Date(),
              "updatedDate": new Date(),
              "userId": this.selectedUserData ? this.selectedUserData.id : 0,
              "subUserId": reportToUser.id,
              "statusId": Status.Active
            })
          })
        }

        if (addUserData.profileImage && (addUserData.profileImage.content == "" || addUserData.profileImage.content == null)) {
          addUserData.profileImage = null;
        }

        addUserData.mainAddress.streetAddress1 = this.addressInput;

        addUserData.mainAddress.streetAddress2 = addUserData.mainAddress && addUserData.mainAddress.streetAddress2 ? addUserData.mainAddress.streetAddress2 : '';
        addUserData.mainAddress.zipCode = addUserData.mainAddress && addUserData.mainAddress.zipCode ? addUserData.mainAddress.zipCode : '';
        addUserData.mainAddress.countryId = this.selectedMCountry ? this.selectedMCountry.id : null;
        addUserData.mainAddress.stateId = this.selectedMState ? this.selectedMState.id : null;
        addUserData.mainAddress.cityId = this.selectedMCity ? this.selectedMCity.id : null;
        addUserData.mainAddressId = 0;

        // if (addUserData.mainAddress.streetAddress1 !== '' && addUserData.mainAddress.streetAddress2 !== '' &&
        //   this.selectedMCountry && this.selectedMState && this.selectedMCity && addUserData.mainAddress.zipCode !== '') {
        //   addUserData.mainAddress.countryId = this.selectedMCountry ? this.selectedMCountry.id : 0;
        //   addUserData.mainAddress.stateId = this.selectedMState ? this.selectedMState.id : 0;
        //   addUserData.mainAddress.cityId = this.selectedMCity ? this.selectedMCity.id : 0;
        // } else {
        //   if (addUserData.mainAddress.streetAddress1 == '' && addUserData.mainAddress.streetAddress2 == '' &&
        //     this.selectedMCountry == null && this.selectedMState == null && this.selectedMCity == null && addUserData.mainAddress.zipCode == '') {

        //     addUserData.mainAddress = null;
        //     addUserData.mainAddressId = 0;
        //   } else {
        //     this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Fill All address details' });
        //     return false;
        //   }
        // }

        addUserData.postalAddress.streetAddress1 = this.addressInputForPostal ? this.addressInputForPostal : "";

        addUserData.postalAddress.streetAddress2 = addUserData.postalAddress && addUserData.postalAddress.streetAddress2 ? addUserData.postalAddress.streetAddress2 : '';
        addUserData.postalAddress.countryId = this.selectedPCountry ? this.selectedPCountry.id : null;
        addUserData.postalAddress.stateId = this.selectedPState ? this.selectedPState.id : null;
        addUserData.postalAddress.cityId = this.selectedPCity ? this.selectedPCity.id : null;
        addUserData.postalAddressId = 0;

        // if (addUserData.postalAddress.streetAddress1 !== '' && addUserData.postalAddress.streetAddress2 !== '' &&
        //   this.selectedPCountry && this.selectedPState && this.selectedPCity && addUserData.postalAddress.zipCode !== '') {
        //   addUserData.postalAddress.countryId = this.selectedPCountry ? this.selectedPCountry.id : null;
        //   addUserData.postalAddress.stateId = this.selectedPState ? this.selectedPState.id : null;
        //   addUserData.postalAddress.cityId = this.selectedPCity ? this.selectedPCity.id : null;
        // } else {
        //   if (addUserData.postalAddress.streetAddress1 == '' && addUserData.postalAddress.streetAddress2 == '' &&
        //     this.selectedPCountry == null && this.selectedPState == null && this.selectedPCity == null && addUserData.postalAddress.zipCode == '') {

        //     addUserData.postalAddress = null;
        //     addUserData.mainAddressId = 0;
        //   } else {
        //     this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Fill All address details' });
        //     return false;
        //   }
        // }


        if (addUserData.userPhones && addUserData.userPhones[0].phone.number == '') {
          addUserData.userPhones = [];
        }
        if (addUserData.userSocialProfiles && addUserData.userSocialProfiles[0].socialProfile.name == '') {
          addUserData.userSocialProfiles = [];
        }
        addUserData.userDetail.timezoneId = this.selectedTimeZone ? this.selectedTimeZone.id : null;

        // if (addUserData.userDetail.joiningDate == null) {
        //   delete addUserData.userDetail.joiningDate;
        // }
        if (addUserData.userDetail.lastLeaveUpdatedDate == null) {
          delete addUserData.userDetail.lastLeaveUpdatedDate;
        }
        if (addUserData.userDetail.maritalStatusId == null) {
          delete addUserData.userDetail.maritalStatusId;
        }
        if (addUserData.userDetail.timezoneId == null) {
          delete addUserData.userDetail.timezoneId;
        }
        // if (addUserData.userDetail.trackingEndTime == null) {
        //   delete addUserData.userDetail.trackingEndTime;
        // }
        // if (addUserData.userDetail.trackingStartTime == null) {
        //   delete addUserData.userDetail.trackingStartTime;
        // }
        addUserData.name = `${addUserData.firstName} ${addUserData.lastName}`;

        let userLanguages: any[] = [];
        if (this.selectedLanguages && this.selectedLanguages.length) {
          this.selectedLanguages.map(sLangObj => {
            const langOb = {
              "userId": addUserData.id,
              "id": 0,
              "createdSource": this.app.user.userIP,
              "updatedSource": this.app.user.userIP,
              "createdBy": this.app.user.userId,
              "updatedBy": this.app.user.userId,
              "createdDate": new Date(),
              "languageId": sLangObj.id,
              "statusId": Status.Active,
              "updatedDate": new Date(),
              "status": null,
            }
            if (this.addEditUserHeader == 'Copy User') {
              langOb.userId = 0;
            }
            userLanguages.push(langOb)
          });
        }

        addUserData.userLanguages = userLanguages;
        this.appMainService.isShowSpinner('saveUser')
        if (this.addEditUserHeader == 'Copy User' ||
          (this.addEditUserHeader == 'Add User' || this.addEditUserHeader == "Ajouter un utilisateur" || this.addEditUserHeader == "添加用户")) {
          // add or copy
          this.service.addUser(addUserData).subscribe(
            resp => {
              this.checkSubscriptionLimit();
              this.getUsersList();
              this.displayAddUser = false;
              this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Added User Successfully...' });
              this.service.notifyUserAdded();
            },
            err => {
              this.appMainService.isHideSpinner('saveUser')
              this.messageService.add({ severity: 'error', summary: 'Error', detail: err.error.Message });
            },
            () => this.appMainService.isHideSpinner('saveUser')
          );
        } else {
          // update
          if (addUserData?.locationIds.length === 0 || null) {
            //this.showAddMore = true;
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Select Working Location' });
            this.appMainService.isHideSpinner('saveUser')
          } else {
            this.service.updateUser(addUserData).subscribe(
              resp => {
                this.getUsersList();
                //this.getRoleWiseUserList();
                if (this.app.userId == addUserData.id) {
                  this.reloadLoggedUserPermissions();
                }
                this.displayAddUser = false;
                this.selectedUserData = null;
                this.service.notifyUserAdded();
                this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Updated User Successfully...' });
              },
              err => {
                this.appMainService.isHideSpinner('saveUser')
                this.messageService.add({ severity: 'error', summary: 'Error', detail: err.error.Message });
              },
              () => this.appMainService.isHideSpinner('saveUser')
            );
          }
        }
      }
    }

  }

  showAddEditUserGroup(userGroupData?, viewType?) {
    this.userGroupForm.reset();
    this.userGroupFormSubmitted = false;
    const selectedUserGroups: any[] = [];
    userGroupData ? this.allUsers.map(user => {
      const selectedUser = userGroupData.groupOwners.find(selectedGroupOwner => selectedGroupOwner.userId == user.id)
      if (selectedUser) {
        selectedUserGroups.push(user);
      }
    }) : [];

    this.isDisabledUserGroupEdit = false;
    this.displayAddUserGroup = true;
    this.selectedParent = null;
    const selectedParentGroup = userGroupData && userGroupData.group.parentGroup ?
      this.allUserGroup.filter(groupObj => groupObj.groupId === userGroupData.group.parentGroup.id) : null;
    this.selectedParent = selectedParentGroup && selectedParentGroup.length ? { ...selectedParentGroup[0] } : null;


    ////console.log('this.tempUserGroup', this.tempUserGroup);
    setTimeout(() => {
      this.tempUserGroup = JSON.parse(JSON.stringify({
        "id": userGroupData ? userGroupData.group.id : 0,
        "createdSource": this.app.userIP,
        "updatedSource": this.app.userIP,
        "createdBy": this.app.user.userId,
        "updatedBy": this.app.user.organizationId,
        "createdDate": new Date().toISOString(),
        "updatedDate": new Date().toISOString(),
        "groupId": "",
        "group": {
          "id": 0,
          "createdSource": this.app.userIP,
          "updatedSource": this.app.userIP,
          "createdBy": this.app.user.userId,
          "updatedBy": this.app.user.organizationId,
          "createdDate": new Date().toISOString(),
          "updatedDate": new Date().toISOString(),
          "name": userGroupData && userGroupData.group ? userGroupData.group.name.trim() : "",
          "isValid": userGroupData ? userGroupData.isValid : "",
          "parentGroupId": selectedParentGroup && selectedParentGroup[0] ? selectedParentGroup[0].groupId : null,
          "parentGroup": this.selectedParent
        },
        "users": userGroupData ? userGroupData.users : [],
        "groupOwners": selectedUserGroups,
        "organizationId": 0,
        "statusId": 0
      }));
      switch (viewType) {
        case 'view':
          this.addEditUserGroupHeader = this.userTranslate.ViewUserGroupHeading;
          this.isDisabledUserGroupEdit = true;
          break;
        case 'add':
          this.addEditUserGroupHeader = this.userTranslate.AddUserGroupHeading;
          break;
        case 'edit':
          this.addEditUserGroupHeader = this.userTranslate.EditUserGroupHeading;
          break;
        case 'copy':
          this.addEditUserGroupHeader = this.userTranslate.CopyUserGroupHeading;
          break;
      }
    });

  }

  userGroupFormSubmitted = false;
  saveUserGroup() {
    // handle group name unique validation

    this.userGroupFormSubmitted = true;
    ////console.log(';addUserGroupForm', this.userGroupForm)
    if (this.userGroupForm.form.valid) {
      ////console.log(this.selectedParent)
      this.tempUserGroup.statusId = 1;
      this.tempUserGroup.organizationId = this.app.user.organizationId;
      ////console.log('tempUserGroup', this.tempUserGroup)
      ////console.log('this.addEditLeadHeader', this.addEditLeadHeader)
      const groupOwnerId: any[] = [];
      this.tempUserGroup.groupOwners.forEach(element => {
        groupOwnerId.push(element.id);
      });
      const req: any[] = [];
      this.tempUserGroup.users.forEach(element => {

        const reqParams = {
          "id": 0,
          "createdSource": this.app.userIP,
          "updatedSource": this.app.userIP,
          "createdBy": this.app.user.userId,
          "updatedBy": this.app.user.userId,
          "createdDate": new Date().toISOString(),
          "updatedDate": new Date().toISOString(),
          "name": this.tempUserGroup.group.name,
          "description": this.tempUserGroup.group.name,
          "organizationId": this.app.user.organizationId,
          "groupId": ((this.addEditUserGroupHeader == "Add User Group" || this.addEditUserGroupHeader == "Copy User Group") ? 0 : this.tempUserGroup.id),
          "group": {
            "id": ((this.addEditUserGroupHeader == "Add User Group" || this.addEditUserGroupHeader == "Copy User Group") ? 0 : this.tempUserGroup.id),
            "createdSource": this.app.userIP,
            "updatedSource": this.app.userIP,
            "createdBy": this.app.user.userId,
            "updatedBy": this.app.user.userId,
            "createdDate": new Date().toISOString(),
            "updatedDate": new Date().toISOString(),
            "name": this.tempUserGroup.group.name,
            "description": this.tempUserGroup.group.name,
            "parentGroupId": this.tempUserGroup.group.parentGroup ? this.tempUserGroup.group.parentGroup.groupId : null,
            "isValid": true,
            "validFromDate": new Date().toISOString(),
            "validToDate": this.addYear(new Date()),
          },
          "userId": element.id,
          "statusId": 1,
          "isValid": true,
          "validFromDate": new Date().toISOString(),
          "validToDate": this.addYear(new Date()),
          "isGroupOwner": (groupOwnerId.includes(element.id) ? true : false)
        }
        req.push(reqParams);
      });

      ////console.log(req);
      let duplicateGroup
      if (this.addEditUserGroupHeader == "Add User Group" || this.addEditUserGroupHeader == "Copy User Group") {
        duplicateGroup = this.allUserGroup.find(obj => obj.group.name == this.tempUserGroup.group.name);
      } else {
        duplicateGroup = this.allUserGroup.find(obj => obj.group.name == this.tempUserGroup.group.name && obj.groupId !== req[0].groupId);
      }
      // need to add validation for edit
      if (duplicateGroup && duplicateGroup.groupId) {
        this.messageService.add({ severity: 'warn', summary: 'Warning', detail: 'User Group name already exists.' });
        return;
      }
      if (this.addEditUserGroupHeader == "Add User Group" || this.addEditUserGroupHeader == "Copy User Group") {
        this.service.saveAddUserGroup(req).subscribe(resp => {
          this.formSubmitted = false;
          if (this.addEditUserGroupHeader == "Add User Group") {
            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'User Group Added Successfully...' });
          } else {
            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'User Group copied Successfully...' });
          }

          this.getUserGroupList();
          this.displayAddUserGroup = false;
        });
      } else {
        //edit
        this.service.updateAddUserGroup(req).subscribe(resp => {
          this.formSubmitted = false;
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'User Group Updated Successfully...' });
          this.getUserGroupList();
          this.displayAddUserGroup = false;
        });
      }
    }
  }

  addYear(d) {
    let year = d.getFullYear();
    let month = d.getMonth();
    let day = d.getDate();
    var c = new Date(year + 10, month, day);
    return c.toISOString();
  }

  showEditUserTemplate(c) {
    this.templateUserTemp = JSON.parse(JSON.stringify(c));
    this.availableUserLabels_info = c.labels_info;
    this.selectedUserLabels_info = c.labels_info;
    this.availableUserLabels_address = c.labels_address;
    this.selectedUserLabels_address = c.labels_address;
    this.availableUserLabels_other_info = c.other_info;
    this.selectedUserLabels_other_info = c.other_info;
    this.displayEditUserTemplate = true;
  }

  showSwapUserLabels(c) {
    this.displaySwapUserLabels = true;
  }

  saveUserTemplateLabelsSwap() {
    return false;
    // dynamic add edit user form not possible now
    let userTemplateconfigTemp = {
      "id": this.userTemplateConfig.id,
      "createdSource": this.app.userIP,
      "updatedSource": this.app.userIP,
      "createdBy": this.app.user.userId,
      "updatedBy": this.app.user.organizationId,
      "createdDate": new Date().toISOString(),
      "updatedDate": new Date().toISOString(),
      "organizationId": this.userTemplateConfig.organizationId,
      "name": this.userTemplateConfig.name,
      "description": this.userTemplateConfig.description,
      "configJSONSchema": "",
      "configJSONValue": "",
      "objectId": this.userTemplateConfig.objectId,
      "levelId": this.userTemplateConfig.levelId,
      "levelRecordId": this.userTemplateConfig.configurationDetails[0].levelRecordId,
      "categoryId": this.userTemplateConfig.categoryId,
      "statusId": 1,
      "typeId": this.userTemplateConfig.typeId
    }
    let arr: any[] = [];
    for (let acc of this.allUserTemplates) {
      if (this.templateUserTemp.id == acc.id) {
        acc.labels_info = JSON.parse(JSON.stringify(this.selectedUserLabels_info));
        acc.labels_address = JSON.parse(JSON.stringify(this.selectedUserLabels_address));
        acc.other_info = JSON.parse(JSON.stringify(this.selectedUserLabels_other_info));
        arr.push(acc)
      } else {
        arr.push(acc);
      }
    }
    this.allUserTemplates = JSON.parse(JSON.stringify(arr))
    userTemplateconfigTemp.configJSONValue = JSON.stringify(this.allUserTemplates);

    this.service.updateConfiguration(userTemplateconfigTemp).then(() => {
      this.messageService.add({ severity: 'success', summary: 'Success', detail: 'User Template updated successfully...' });
      this.displaySwapUserLabels = false;
    }).catch(() => {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error occurred while saving data...' });
    });

  }

  dropUserTemplateField(event: CdkDragDrop<string[]>) {
    if (event.previousContainer === event.container) {
      moveItemInArray(
        event.container.data,
        event.previousIndex,
        event.currentIndex
      );
    } else {
      transferArrayItem(
        event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex
      );
    }
  }

  updateUserTemplate() {
    let userTemplateconfigTemp = {
      "id": this.userTemplateConfig.id,
      "createdSource": this.app.userIP,
      "updatedSource": this.app.userIP,
      "createdBy": this.app.user.userId,
      "updatedBy": this.app.user.organizationId,
      "createdDate": new Date().toISOString(),
      "updatedDate": new Date().toISOString(),
      "organizationId": this.userTemplateConfig.organizationId,
      "name": this.userTemplateConfig.name,
      "description": this.userTemplateConfig.description,
      "configJSONSchema": "",
      "configJSONValue": "",
      "objectId": this.userTemplateConfig.objectId,
      "levelId": this.userTemplateConfig.levelId,
      "levelRecordId": this.userTemplateConfig.configurationDetails[0].levelRecordId,
      "categoryId": this.userTemplateConfig.categoryId,
      "statusId": 1,
      "typeId": this.userTemplateConfig.typeId
    }
    let arr: any[] = [];
    for (let acc of this.allUserTemplates) {
      if (this.templateUserTemp.id == acc.id) {
        acc.labels_info = JSON.parse(JSON.stringify(this.selectedUserLabels_info));
        acc.labels_address = JSON.parse(JSON.stringify(this.selectedUserLabels_address));
        acc.other_info = JSON.parse(JSON.stringify(this.selectedUserLabels_other_info));
        arr.push(acc)
      } else {
        arr.push(acc);
      }
    }
    this.allUserTemplates = JSON.parse(JSON.stringify(arr))
    userTemplateconfigTemp.configJSONValue = JSON.stringify(this.allUserTemplates);

    this.service.updateConfiguration(userTemplateconfigTemp).then(() => {
      this.messageService.add({ severity: 'success', summary: 'Success', detail: 'User Template updated successfully...' });
      this.displayEditUserTemplate = false;
    }).catch(() => {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error occurred while saving data...' });
    });
  }


  selectedUserRow1(checkValue) {
    if (checkValue) {
      for (let s of this.selectedUserLabels_info) {
        s.checked = true;
      }
    } else {
      for (let s of this.selectedUserLabels_info) {
        if (s.movable == true) {
          s.checked = false;
        }
      }
    }
  }
  selectedUserRow2(checkValue) {
    if (checkValue) {
      for (let s of this.selectedUserLabels_address) {
        s.checked = true;
      }
    } else {
      for (let s of this.selectedUserLabels_address) {
        if (s.movable == true) {
          s.checked = false;
        }
      }
    }
  }
  selectedUserRow3(checkValue) {
    if (checkValue) {
      for (let s of this.selectedUserLabels_other_info) {
        s.checked = true;
      }
    } else {
      for (let s of this.selectedUserLabels_other_info) {
        if (s.movable == true || s.width == 2) {
          s.checked = false;
        }
      }
    }
  }


  //   Contacts

  loadContactRoles() {
    this.appMainService.isShowSpinner('getUsersList');
    this.service.getContactRoles().subscribe(
      resp => {
        this.contactRoles = resp && resp.length ? resp : [];
        this.appMainService.isHideSpinner('getUsersList');
      },
      err => {
        this.appMainService.isHideSpinner('getUsersList');
      },
    );
  }

  trimGroupName() {
    // this.tempUserGroup.group.name = this.tempUserGroup.group.name.trim();
  }

  getChangeContact(event) {
    if (this.addEditContactHeader == 'Add Contact Stage' || this.addEditContactHeader == 'Edit Contact Stage') {
      this.tempContactStage.description = event;
    }
    // if (this.addEditContactHeader == 'Add Field Data' || this.addEditContactHeader == 'Edit Field Data') {
    //   this.contactDataTemp.description = event;
    // }
  }

  contactDataFormSubmitted = false;
  showAddContactData(loadedModule?) {
    this.fieldTypeSelectionError = false;
    this.contactDataFormSubmitted = false;
    this.currentModule = loadedModule;
    this.displayAddContactData = true;
    this.addEditContactHeader = this.userTranslate.AddFieldDataHeading;
    this.invalidData = false;
    this.contactDataTemp = {
      "name": "",
      "description": "",
      "id": 0,
      "code": "",
      "checked": true,
      "groupId": null,
      "organizationId": this.app.user.organizationId
    }
  }

  getContactDataType() {
    switch (this.selectedContactDataType?.name) {
      case 'Annual Income':
        this.activeAccordionIndex = 0;
        break;
      case 'Degree':
        this.activeAccordionIndex = 1;
        break;
      case 'Field of Study':
        this.activeAccordionIndex = 2;
        break;
      case 'Gender':
        this.activeAccordionIndex = 3;
        break;
      case 'Language Spoken':
        this.activeAccordionIndex = 4;
        break;
      case 'Marital Status':
        this.activeAccordionIndex = 5;
        break;
      default:
        this.activeAccordionIndex = 6;
    }
    this.onOpenAccordion(null);
    if (this.selectedContactDataType ? this.selectedContactDataType.code == 'email type' : null
      || this.selectedContactDataType ? this.selectedContactDataType.code == 'phone type' : null
        || this.selectedContactDataType ? this.selectedContactDataType.code == 'social type' : null) {
      this.contactDataTemp = {
        "name": "",
        "description": "",
        "id": 0,
        "code": "",
        "checked": false
      }
    }
    else if (this.selectedContactDataType ? this.selectedContactDataType.code == 'jobType' : null) {
      this.contactDataTemp = {
        "name": "",
        "description": "",
      }
    }
    else {
      this.contactDataTemp = {
        "id": 0,
        "createdSource": this.app.userIP,
        "updatedSource": this.app.userIP,
        "createdBy": this.app.user.userId,
        "updatedBy": this.app.user.userId,
        "createdDate": new Date().toISOString(),
        "updatedDate": new Date().toISOString(),
        "name": "",
        "parentTypeId": 0,
        "description": "",
        "groupId": 12,
        "group": null,
        "statusId": 1,
        "status": null,
        "organizationId": this.app.user.organizationId,
        "colorCodeId": null
      }
    }
  }
  showEditContactData(c, s) {
    this.contactDataFormSubmitted = false;
    this.contactDataTemp = JSON.parse(JSON.stringify(c));
    this.contactTypeId = s.id;
    this.addEditContactHeader = this.userTranslate.EditFieldDataHeading;
    this.displayAddContactData = true;
  }

  saveContactDataAdd() {
    if ((this.addEditContactHeader == "Add Field Data" || this.addEditContactHeader == "Ajouter des données de champ" || this.addEditContactHeader == "添加字段数据")
      && !this.selectedContactDataType) {
      this.contactDataFormSubmitted = true;
      this.fieldTypeSelectionError = true;
      return false;
    }

    if (this.addEditContactHeader == "Add Field Data" || this.addEditContactHeader == "Ajouter des données de champ" || this.addEditContactHeader == "添加字段数据") {
      if (this.selectedContactDataType && this.selectedContactDataType.code == 'contact type') {
        let lowerContactNames: any[] = [];
        for (let s of this.contactTypes) {
          lowerContactNames.push(s.name.toLowerCase())
        }
        if (lowerContactNames.indexOf(this.contactDataTemp.name.toLowerCase()) > -1) {
          this.invalidData = true;
        } else {
          this.service.addContactType(this.contactDataTemp).then(stages => {
            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Added Successfully...' });
            this.contactService.getAllContactTypes().then(types => {
              this.contactTypes = types;
            });
            this.displayAddContactData = false;
            this.selectedContactDataType = null;
          });
        }
      } else if (this.selectedContactDataType && this.selectedContactDataType.code == 'gender') {
        let lowerContactNames: any[] = [];
        for (let s of this.genders) {
          lowerContactNames.push(s.name.toLowerCase())
        }
        if (lowerContactNames.indexOf(this.contactDataTemp.name.toLowerCase()) > -1) {
          this.invalidData = true;
        } else {
          this.service.addGender(this.contactDataTemp).then(stages => {
            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Added Successfully...' });
            this.contactService.getAllGender().then(genders => {
              this.genders = genders;
            });
            this.displayAddContactData = false;
            this.selectedContactDataType = null;

          });
        }
      } else if (this.selectedContactDataType && this.selectedContactDataType.code == 'language') {
        let lowerContactNames: any[] = [];
        for (let s of this.languages) {
          lowerContactNames.push(s.name.toLowerCase())
        }
        if (lowerContactNames.indexOf(this.contactDataTemp.name.toLowerCase()) > -1) {
          this.invalidData = true;
        } else {
          this.service.addLanguage(this.contactDataTemp).then(stages => {
            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Added Successfully...' });
            this.contactService.getAllLanguage().then(languages => {
              this.languages = languages;
            });
            this.displayAddContactData = false;
            this.selectedContactDataType = null;

          });
        }
      } else if (this.selectedContactDataType && this.selectedContactDataType.code == 'relation') {
        let lowerContactNames: any[] = [];
        for (let s of this.relations) {
          lowerContactNames.push(s.name.toLowerCase())
        }
        if (lowerContactNames.indexOf(this.contactDataTemp.name.toLowerCase()) > -1) {
          this.invalidData = true;
        } else {
          this.service.addRelationshipStatus(this.contactDataTemp).then(stages => {
            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Added Successfully...' });
            this.contactService.getAllRelationshipStatus().then(status => {
              this.relations = status;
            });
            this.displayAddContactData = false;
            this.selectedContactDataType = null;

          });
        }
      } else if (this.selectedContactDataType && this.selectedContactDataType.code == 'marital') {
        let lowerContactNames: any[] = [];
        for (let s of this.maritals) {
          lowerContactNames.push(s.name.toLowerCase())
        }
        if (lowerContactNames.indexOf(this.contactDataTemp.name.toLowerCase()) > -1) {
          this.invalidData = true;
        } else {
          this.service.addMaritalStatus(this.contactDataTemp).then(stages => {
            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Added Successfully...' });
            this.contactService.getAllMaritalStatus().then(status => {
              this.maritals = status;
            });
            this.displayAddContactData = false;
            this.selectedContactDataType = null;

          });
        }
      } else if (this.selectedContactDataType && this.selectedContactDataType.code == 'contact source') {
        let lowerContactNames: any[] = [];
        for (let s of this.contactSources) {
          lowerContactNames.push(s.name.toLowerCase())
        }
        if (lowerContactNames.indexOf(this.contactDataTemp.name.toLowerCase()) > -1) {
          this.invalidData = true;
        } else {
          this.service.addContactSource(this.contactDataTemp).then(stages => {
            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Added Successfully...' });
            this.contactService.getAllContactSource().then(sources => {
              this.contactSources = sources;
            });
            this.displayAddContactData = false;
            this.selectedContactDataType = null;

          });
        }
      } else if (this.selectedContactDataType && this.selectedContactDataType.code == 'income') {
        let lowerContactNames: any[] = [];
        for (let s of this.incomes) {
          lowerContactNames.push(s.name.toLowerCase())
        }
        if (lowerContactNames.indexOf(this.contactDataTemp.name.toLowerCase()) > -1) {
          this.invalidData = true;
        } else {
          this.service.addAnnualIncome(this.contactDataTemp).then(stages => {
            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Added Successfully...' });
            this.contactService.getAllAnnualIncome().then(incomes => {
              this.incomes = incomes;
            });
            this.displayAddContactData = false;
            this.selectedContactDataType = null;

          });
        }
      } else if (this.selectedContactDataType && this.selectedContactDataType.code == 'degree') {
        let lowerContactNames: any[] = [];
        for (let s of this.degrees) {
          lowerContactNames.push(s.name.toLowerCase())
        }
        if (lowerContactNames.indexOf(this.contactDataTemp.name.toLowerCase()) > -1) {
          this.invalidData = true;
        } else {
          this.service.addDegree(this.contactDataTemp).then(stages => {
            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Added Successfully...' });
            this.contactService.getAllDegree().then(degrees => {
              this.degrees = degrees;
            });
            this.displayAddContactData = false;
            this.selectedContactDataType = null;

          });
        }
      } else if (this.selectedContactDataType && this.selectedContactDataType.code == 'study field') {
        let lowerContactNames: any[] = [];
        for (let s of this.studyFields) {
          lowerContactNames.push(s.name.toLowerCase())
        }
        if (lowerContactNames.indexOf(this.contactDataTemp.name.toLowerCase()) > -1) {
          this.invalidData = true;
        } else {
          this.service.addStudyField(this.contactDataTemp).then(stages => {
            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Added Successfully...' });
            this.contactService.getAllStudyField().then(fields => {
              this.studyFields = fields;
            });
            this.displayAddContactData = false;
            this.selectedContactDataType = null;

          });
        }
      } else if (this.selectedContactDataType && this.selectedContactDataType.code == 'email type') {
        let lowerContactNames: any[] = [];
        for (let s of this.emailtype) {
          lowerContactNames.push(s.name.toLowerCase())
        }
        if (lowerContactNames.indexOf(this.contactDataTemp.name.toLowerCase()) > -1) {
          this.invalidData = true;
        } else {
          this.configTemp = {
            "id": this.emailConfig.id,
            "createdSource": this.app.userIP,
            "updatedSource": this.app.userIP,
            createdBy: this.app.user.userId,
            "updatedBy": this.app.user.organizationId,
            "createdDate": new Date().toISOString(),
            "updatedDate": new Date().toISOString(),
            "organizationId": this.emailConfig.organizationId,
            "name": this.emailConfig.name,
            "description": this.emailConfig.description,
            "configJSONSchema": "",
            "configJSONValue": "",
            "objectId": this.emailConfig.objectId,
            "levelId": this.emailConfig.levelId,
            "levelRecordId": this.emailConfig.configurationDetails[0].levelRecordId,
            "categoryId": this.emailConfig.categoryId,
            "statusId": 1,
            "typeId": this.emailConfig.typeId
          }
          this.contactDataTemp.id = this.emailtype.length + 1;
          this.contactDataTemp.code = 'other';
          this.emailtype.push(this.contactDataTemp);
          this.configTemp.configJSONValue = JSON.stringify(this.emailtype);

          this.service.updateConfiguration(this.configTemp).then(stages => {
            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Added Successfully...' });
            // this.service.getAllConfiguration().subscribe(configs => {
            //   this.app.configurationData.next(configs);
            //   this.emailConfig = configs.filter(s => s.name == ObjectNames.CONTACTS_EMAIL_TYPES && s.typeId == 93)[0];
            //   this.emailtype = JSON.parse(this.emailConfig.configurationDetails[0].configJSONValue);
            // });
            this.getUserConfiguration();
            this.displayAddContactData = false;
            this.selectedContactDataType = null;

          });
        }
      } else if (this.selectedContactDataType && this.selectedContactDataType.code == 'phone type') {
        let lowerContactNames: any[] = [];
        for (let s of this.phonetype) {
          lowerContactNames.push(s.name.toLowerCase())
        }
        if (lowerContactNames.indexOf(this.contactDataTemp.name.toLowerCase()) > -1) {
          this.invalidData = true;
        } else {
          this.configTemp = {
            "id": this.phoneConfig.id,
            "createdSource": this.app.userIP,
            "updatedSource": this.app.userIP,
            createdBy: this.app.user.userId,
            "updatedBy": this.app.user.organizationId,
            "createdDate": new Date().toISOString(),
            "updatedDate": new Date().toISOString(),
            "organizationId": this.phoneConfig.organizationId,
            "name": this.phoneConfig.name,
            "description": this.phoneConfig.description,
            "configJSONSchema": "",
            "configJSONValue": "",
            "objectId": this.phoneConfig.objectId,
            "levelId": this.phoneConfig.levelId,
            "levelRecordId": this.phoneConfig.configurationDetails[0].levelRecordId,
            "categoryId": this.phoneConfig.categoryId,
            "statusId": 1,
            "typeId": this.phoneConfig.typeId
          }
          this.contactDataTemp.id = this.phonetype.length + 1;
          this.contactDataTemp.code = 'other';
          this.phonetype.push(this.contactDataTemp);
          this.configTemp.configJSONValue = JSON.stringify(this.phonetype);

          this.service.updateConfiguration(this.configTemp).then(stages => {
            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Added Successfully...' });
            // this.service.getAllConfiguration().subscribe(configs => {
            //   this.app.configurationData.next(configs);
            //   this.phoneConfig = configs.filter(s => s.name == ObjectNames.CONTACTS_PHONE_TYPES && s.typeId == 93)[0];
            //   this.phonetype = JSON.parse(this.phoneConfig.configurationDetails[0].configJSONValue);
            // });
            this.getUserConfiguration();
            this.displayAddContactData = false;
            this.selectedContactDataType = null;

          });
        }
      } else if (this.selectedContactDataType && this.selectedContactDataType.code == 'social type') {
        let lowerContactNames: any[] = [];
        for (let s of this.socials) {
          lowerContactNames.push(s.name.toLowerCase())
        }
        if (lowerContactNames.indexOf(this.contactDataTemp.name.toLowerCase()) > -1) {
          this.invalidData = true;
        } else {
          this.configTemp = {
            "id": this.socialConfig.id,
            "createdSource": this.app.userIP,
            "updatedSource": this.app.userIP,
            createdBy: this.app.user.userId,
            "updatedBy": this.app.user.organizationId,
            "createdDate": new Date().toISOString(),
            "updatedDate": new Date().toISOString(),
            "organizationId": this.socialConfig.organizationId,
            "name": this.socialConfig.name,
            "description": this.socialConfig.description,
            "configJSONSchema": "",
            "configJSONValue": "",
            "objectId": this.socialConfig.objectId,
            "levelId": this.socialConfig.levelId,
            "levelRecordId": this.socialConfig.configurationDetails[0].levelRecordId,
            "categoryId": this.socialConfig.categoryId,
            "statusId": 1,
            "typeId": this.socialConfig.typeId
          }
          this.contactDataTemp.id = this.socials.length + 1;
          this.contactDataTemp.code = 'other';
          this.socials.push(this.contactDataTemp);
          this.configTemp.configJSONValue = JSON.stringify(this.socials);

          this.service.updateConfiguration(this.configTemp).then(stages => {
            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Added Successfully...' });
            // this.service.getAllConfiguration().subscribe(configs => {
            //   this.app.configurationData.next(configs);
            //   this.socialConfig = configs.filter(s => s.name == ObjectNames.CONTACTS_SOCIAL_TYPES && s.typeId == 95)[0];
            //   this.socials = JSON.parse(this.socialConfig.configurationDetails[0].configJSONValue);
            // });
            this.getUserConfiguration();
            this.displayAddContactData = false;
            this.selectedContactDataType = null;

          });
        }
      } else if (this.selectedContactDataType && this.selectedContactDataType.code == 'role') {
        let lowerContactNames: any[] = [];
        for (let s of this.contactRoles) {
          lowerContactNames.push(s.name.toLowerCase())
        }
        if (lowerContactNames.indexOf(this.contactDataTemp.name.toLowerCase()) > -1) {
          this.invalidData = true;
        } else {
          this.contactDataTemp.groupId = TypeGroupIds.JobFuctionsContactAPI;
          this.service.addContactRole(this.contactDataTemp).subscribe(stages => {
            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Added Successfully...' });
            this.loadContactRoles();
            this.displayAddContactData = false;
            this.selectedContactDataType = null;

          });
        }
      }
      else if (this.selectedContactDataType && this.selectedContactDataType.code == 'jobType') {
        this.addJobType();
      }
    } else if (this.addEditContactHeader == "Edit Field Data" || this.addEditContactHeader == "编辑字段数据"
      || this.addEditContactHeader == "Modifier les données de champ") {

      if (this.contactTypeId == 0) {
        if (!this.contactDataTemp.name) {
          this.contactDataFormSubmitted = true;
          this.fieldTypeSelectionError = true;
          return false;
        }
        const duplicateRecord = this.contactTypes.find(depOb => depOb.name.toLowerCase() == this.contactDataTemp.name.toLowerCase() && depOb.id !== this.contactDataTemp.id)
        if (duplicateRecord) {
          this.invalidData = true;
        } else {
          this.invalidData = false;
        }
        if (!this.invalidData) {
          this.service.EditContactType(this.contactDataTemp).then(stages => {
            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Updated Successfully...' });
            this.contactService.getAllContactTypes().then(types => {
              this.contactTypes = types;
            });
            this.displayAddContactData = false;
            this.selectedContactDataType = null;
          });
        }
      } else if (this.contactTypeId == 1) {
        if (!this.contactDataTemp.name) {
          this.contactDataFormSubmitted = true;
          this.fieldTypeSelectionError = true;
          return false;
        }

        const duplicateRecord = this.genders.find(obj => obj.name.toLowerCase() == this.contactDataTemp.name.toLowerCase() && obj.id !== this.contactDataTemp.id)
        if (duplicateRecord) {
          this.invalidData = true;
        } else {
          this.invalidData = false;
        }
        if (!this.invalidData) {
          this.service.EditGender(this.contactDataTemp).then(stages => {
            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Updated Successfully...' });
            this.contactService.getAllGender().then(genders => {
              this.genders = genders;
            });
            this.displayAddContactData = false;
            this.selectedContactDataType = null;

          });
        }
      } else if (this.contactTypeId == 2) {
        if (!this.contactDataTemp.name) {
          this.contactDataFormSubmitted = true;
          this.fieldTypeSelectionError = true;
          return false;
        }

        const duplicateRecord = this.languages.find(obj => obj.name.toLowerCase() == this.contactDataTemp.name.toLowerCase() && obj.id !== this.contactDataTemp.id)
        if (duplicateRecord) {
          this.invalidData = true;
        } else {
          this.invalidData = false;
        }


        if (!this.invalidData) {
          this.service.EditLanguage(this.contactDataTemp).then(stages => {
            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Updated Successfully...' });
            this.contactService.getAllLanguage().then(languages => {
              this.languages = languages;
            });
            this.displayAddContactData = false;
            this.selectedContactDataType = null;
          });
        }
      } else if (this.contactTypeId == 3) {
        if (!this.contactDataTemp.name) {
          this.contactDataFormSubmitted = true;
          this.fieldTypeSelectionError = true;
          return false;
        }

        const duplicateRecord = this.relations.find(obj => obj.name.toLowerCase() == this.contactDataTemp.name.toLowerCase() && obj.id !== this.contactDataTemp.id)
        if (duplicateRecord) {
          this.invalidData = true;
        } else {
          this.invalidData = false;
        }

        if (!this.invalidData) {
          this.service.EditRelationshipStatus(this.contactDataTemp).then(stages => {
            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Updated Successfully...' });
            this.contactService.getAllRelationshipStatus().then(status => {
              this.relations = status;
            });
            this.displayAddContactData = false;
            this.selectedContactDataType = null;

          });
        }
      } else if (this.contactTypeId == 4) {
        if (!this.contactDataTemp.name) {
          this.contactDataFormSubmitted = true;
          this.fieldTypeSelectionError = true;
          return false;
        }
        const duplicateRecord = this.maritals.find(obj => obj.name.toLowerCase() == this.contactDataTemp.name.toLowerCase() && obj.id !== this.contactDataTemp.id)
        if (duplicateRecord) {
          this.invalidData = true;
        } else {
          this.invalidData = false;
        }

        if (!this.invalidData) {
          this.service.EditMaritalStatus(this.contactDataTemp).then(stages => {
            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Updated Successfully...' });
            this.contactService.getAllMaritalStatus().then(status => {
              this.maritals = status;
            });
            this.displayAddContactData = false;
            this.selectedContactDataType = null;

          });

        }
      } else if (this.contactTypeId == 5) {
        if (!this.contactDataTemp.name) {
          this.contactDataFormSubmitted = true;
          this.fieldTypeSelectionError = true;
          return false;
        }
        const duplicateRecord = this.contactSources.find(obj => obj.name.toLowerCase() == this.contactDataTemp.name.toLowerCase() && obj.id !== this.contactDataTemp.id)
        if (duplicateRecord) {
          this.invalidData = true;
        } else {
          this.invalidData = false;
        }


        if (!this.invalidData) {
          this.service.EditContactSource(this.contactDataTemp).then(stages => {
            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Updated Successfully...' });
            this.contactService.getAllContactSource().then(sources => {
              this.contactSources = sources;
            });
            this.displayAddContactData = false;
            this.selectedContactDataType = null;
          });
        }
      } else if (this.contactTypeId == 6) {
        if (!this.contactDataTemp.name) {
          this.contactDataFormSubmitted = true;
          this.fieldTypeSelectionError = true;
          return false;
        }
        const duplicateRecord = this.incomes.find(obj => obj.name.toLowerCase() == this.contactDataTemp.name.toLowerCase() && obj.id !== this.contactDataTemp.id)
        if (duplicateRecord) {
          this.invalidData = true;
        } else {
          this.invalidData = false;
        }

        if (!this.invalidData) {
          this.service.EditAnnualIncome(this.contactDataTemp).then(stages => {
            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Updated Successfully...' });
            this.contactService.getAllAnnualIncome().then(incomes => {
              this.incomes = incomes;
            });
            this.displayAddContactData = false;
            this.selectedContactDataType = null;

          });
        }
      } else if (this.contactTypeId == 7) {
        if (!this.contactDataTemp.name) {
          this.contactDataFormSubmitted = true;
          this.fieldTypeSelectionError = true;
          return false;
        }

        const duplicateRecord = this.degrees.find(obj => obj.name.toLowerCase() == this.contactDataTemp.name.toLowerCase() && obj.id !== this.contactDataTemp.id)
        if (duplicateRecord) {
          this.invalidData = true;
        } else {
          this.invalidData = false;
        }

        if (!this.invalidData) {
          this.service.EditDegree(this.contactDataTemp).then(stages => {
            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Updated Successfully...' });
            this.contactService.getAllDegree().then(degrees => {
              this.degrees = degrees;
            });
            this.displayAddContactData = false;
            this.selectedContactDataType = null;

          });
        }
      } else if (this.contactTypeId == 8) {
        if (!this.contactDataTemp.name) {
          this.contactDataFormSubmitted = true;
          this.fieldTypeSelectionError = true;
          return false;
        }

        const duplicateRecord = this.studyFields.find(obj => obj.name.toLowerCase() == this.contactDataTemp.name.toLowerCase() && obj.id !== this.contactDataTemp.id)
        if (duplicateRecord) {
          this.invalidData = true;
        } else {
          this.invalidData = false;
        }


        if (!this.invalidData) {
          this.service.EditStudyField(this.contactDataTemp).then(stages => {
            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Updated Successfully...' });
            this.contactService.getAllStudyField().then(fields => {
              this.studyFields = fields;
            });
            this.displayAddContactData = false;
            this.selectedContactDataType = null;

          });
        }
      } else if (this.contactTypeId == 9) {

        if (!this.contactDataTemp.name) {
          this.contactDataFormSubmitted = true;
          this.fieldTypeSelectionError = true;
          return false;
        }

        const duplicateRecord = this.emailtype.find(obj => obj.name.toLowerCase() == this.contactDataTemp.name.toLowerCase() && obj.id !== this.contactDataTemp.id)
        if (duplicateRecord) {
          this.invalidData = true;
        } else {
          this.invalidData = false;
        }

        if (!this.invalidData) {
          this.configTemp = {
            "id": this.emailConfig.id,
            "createdSource": this.app.userIP,
            "updatedSource": this.app.userIP,
            createdBy: this.app.user.userId,
            "updatedBy": this.app.user.organizationId,
            "createdDate": new Date().toISOString(),
            "updatedDate": new Date().toISOString(),
            "organizationId": this.emailConfig.organizationId,
            "name": this.emailConfig.name,
            "description": this.emailConfig.description,
            "configJSONSchema": "",
            "configJSONValue": "",
            "objectId": this.emailConfig.objectId,
            "levelId": this.emailConfig.levelId,
            "levelRecordId": this.emailConfig.configurationDetails[0].levelRecordId,
            "categoryId": this.emailConfig.categoryId,
            "statusId": 1,
            "typeId": this.emailConfig.typeId
          }
          let arr: any[] = [];
          for (let s of this.emailtype) {
            if (s.id == this.contactDataTemp.id) {
              s = JSON.parse(JSON.stringify(this.contactDataTemp));
              arr.push(s)
            } else {
              arr.push(s);
            }
          }
          this.emailtype = JSON.parse(JSON.stringify(arr))
          this.configTemp.configJSONValue = JSON.stringify(this.emailtype);

          this.service.updateConfiguration(this.configTemp).then(stages => {
            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Added Successfully...' });
            // this.service.getAllConfiguration().subscribe(configs => {
            //   this.app.configurationData.next(configs);
            //   this.emailConfig = configs.filter(s => s.name == ObjectNames.CONTACTS_EMAIL_TYPES && s.typeId == 93)[0];
            //   this.emailtype = JSON.parse(this.emailConfig.configurationDetails[0].configJSONValue);
            // });
            this.getUserConfiguration();
            this.displayAddContactData = false;
            this.selectedContactDataType = null;

          });
        }
      } else if (this.contactTypeId == 10) {

        if (!this.contactDataTemp.name) {
          this.contactDataFormSubmitted = true;
          this.fieldTypeSelectionError = true;
          return false;
        }

        const duplicateRecord = this.phonetype.find(obj => obj.name.toLowerCase() == this.contactDataTemp.name.toLowerCase() && obj.id !== this.contactDataTemp.id)
        if (duplicateRecord) {
          this.invalidData = true;
        } else {
          this.invalidData = false;
        }

        if (!this.invalidData) {
          this.configTemp = {
            "id": this.phoneConfig.id,
            "createdSource": this.app.userIP,
            "updatedSource": this.app.userIP,
            createdBy: this.app.user.userId,
            "updatedBy": this.app.user.organizationId,
            "createdDate": new Date().toISOString(),
            "updatedDate": new Date().toISOString(),
            "organizationId": this.phoneConfig.organizationId,
            "name": this.phoneConfig.name,
            "description": this.phoneConfig.description,
            "configJSONSchema": "",
            "configJSONValue": "",
            "objectId": this.phoneConfig.objectId,
            "levelId": this.phoneConfig.levelId,
            "levelRecordId": this.phoneConfig.configurationDetails[0].levelRecordId,
            "categoryId": this.phoneConfig.categoryId,
            "statusId": 1,
            "typeId": this.phoneConfig.typeId
          }
          let arr: any[] = [];
          for (let s of this.phonetype) {
            if (s.id == this.contactDataTemp.id) {
              s = JSON.parse(JSON.stringify(this.contactDataTemp));
              arr.push(s)
            } else {
              arr.push(s);
            }
          }
          this.phonetype = JSON.parse(JSON.stringify(arr))
          this.configTemp.configJSONValue = JSON.stringify(this.phonetype);

          this.service.updateConfiguration(this.configTemp).then(stages => {
            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Added Successfully...' });
            // this.service.getAllConfiguration().subscribe(configs => {
            //   this.app.configurationData.next(configs);
            //   this.phoneConfig = configs.filter(s => s.name == ObjectNames.CONTACTS_PHONE_TYPES && s.typeId == 93)[0];
            //   this.phonetype = JSON.parse(this.phoneConfig.configurationDetails[0].configJSONValue);
            // });
            this.getUserConfiguration();
            this.displayAddContactData = false;
            this.selectedContactDataType = null;

          });
        }
      } else if (this.contactTypeId == 11) {
        if (!this.contactDataTemp.name) {
          this.contactDataFormSubmitted = true;
          this.fieldTypeSelectionError = true;
          return false;
        }

        const duplicateRecord = this.socials.find(obj => obj.name.toLowerCase() == this.contactDataTemp.name.toLowerCase() && obj.id !== this.contactDataTemp.id)
        if (duplicateRecord) {
          this.invalidData = true;
        } else {
          this.invalidData = false;
        }

        if (!this.invalidData) {
          this.configTemp = {
            "id": this.socialConfig.id,
            "createdSource": this.app.userIP,
            "updatedSource": this.app.userIP,
            createdBy: this.app.user.userId,
            "updatedBy": this.app.user.organizationId,
            "createdDate": new Date().toISOString(),
            "updatedDate": new Date().toISOString(),
            "organizationId": this.socialConfig.organizationId,
            "name": this.socialConfig.name,
            "description": this.socialConfig.description,
            "configJSONSchema": "",
            "configJSONValue": "",
            "objectId": this.socialConfig.objectId,
            "levelId": this.socialConfig.levelId,
            "levelRecordId": this.socialConfig.configurationDetails[0].levelRecordId,
            "categoryId": this.socialConfig.categoryId,
            "statusId": 1,
            "typeId": this.socialConfig.typeId
          }
          let arr: any[] = [];
          for (let s of this.socials) {
            if (s.id == this.contactDataTemp.id) {
              s = JSON.parse(JSON.stringify(this.contactDataTemp));
              arr.push(s)
            } else {
              arr.push(s);
            }
          }
          this.socials = JSON.parse(JSON.stringify(arr))
          this.configTemp.configJSONValue = JSON.stringify(this.socials);

          this.service.updateConfiguration(this.configTemp).then(stages => {
            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Added Successfully...' });
            // this.service.getAllConfiguration().subscribe(configs => {
            //   this.app.configurationData.next(configs);
            //   this.socialConfig = configs.filter(s => s.name == ObjectNames.CONTACTS_SOCIAL_TYPES && s.typeId == 95)[0];
            //   this.socials = JSON.parse(this.socialConfig.configurationDetails[0].configJSONValue);
            // });
            this.getUserConfiguration();
            this.displayAddContactData = false;
            this.selectedContactDataType = null;
          });
        }
      } else if (this.contactTypeId == 12) {
        if (!this.contactDataTemp.name) {
          this.contactDataFormSubmitted = true;
          this.fieldTypeSelectionError = true;
          return false;
        }

        const duplicateRecord = this.contactRoles.find(obj => obj.name.toLowerCase() == this.contactDataTemp.name.toLowerCase() && obj.id !== this.contactDataTemp.id)
        if (duplicateRecord) {
          this.invalidData = true;
        } else {
          this.invalidData = false;
        }


        if (!this.invalidData) {
          this.service.updateContactRole(this.contactDataTemp).subscribe(stages => {
            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Updated Roles Successfully...' });
            this.loadContactRoles();
            this.displayAddContactData = false;
            this.selectedContactDataType = null;
          });
        }
      }
      else if (this.contactTypeId == 14) {
        this.editJobType();
      }
    }
  }

  delGender(c) {
    this.confirmationService.confirm({
      message: this.userTranslate.GenderDeleteConfirmationMsg,
      header: this.userTranslate.DeleteConfirmationHeader,
      icon: 'pi pi-info-circle',
      accept: () => {
        this.service.deleteGender(c.id).then(() => {
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Deleted Successfully...' });
          this.contactService.getAllGender().then(genders => {
            this.genders = genders;
          });
        }).catch(() => {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error occurred while deleting data...' });
        });
      },
      reject: () => {
      }
    });
  }
  delLanguage(c) {
    this.confirmationService.confirm({
      message: this.userTranslate.LanguageDeleteConfirmationMsg,
      header: this.userTranslate.DeleteConfirmationHeader,
      icon: 'pi pi-info-circle',
      accept: () => {
        this.service.deleteLanguage(c.id).then(() => {
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Deleted Successfully...' });
          this.contactService.getAllLanguage().then(languages => {
            this.languages = languages;
          });
        }).catch(() => {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error occurred while deleting data...' });
        });
      },
      reject: () => {
      }
    });
  }
  delRelationshipStatus(c) {
    this.confirmationService.confirm({
      message: this.userTranslate.RelationshipStatusDeleteConfirmationMsg,
      header: this.userTranslate.DeleteConfirmationHeader,
      icon: 'pi pi-info-circle',
      accept: () => {
        this.service.deleteRelationshipStatus(c.id).then(() => {
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Deleted Successfully...' });
          this.contactService.getAllRelationshipStatus().then(status => {
            this.relations = status;
          });
        }).catch(() => {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error occurred while deleting data...' });
        });
      },
      reject: () => {
      }
    });
  }
  delMaritalStatus(c) {
    this.confirmationService.confirm({
      message: this.userTranslate.MaritalStatusDeleteConfirmationMsg,
      header: this.userTranslate.DeleteConfirmationHeader,
      icon: 'pi pi-info-circle',
      accept: () => {
        this.service.deleteMaritalStatus(c.id).then(() => {
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Deleted Successfully...' });
          this.contactService.getAllMaritalStatus().then(status => {
            this.maritals = status;
          });
        }).catch(() => {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error occurred while deleting data...' });
        });
      },
      reject: () => {
      }
    });
  }

  delAnnualIncome(c) {
    this.confirmationService.confirm({
      message: this.userTranslate.AnnualIncomeDeleteConfirmationMsg,
      header: this.userTranslate.DeleteConfirmationHeader,
      icon: 'pi pi-info-circle',
      accept: () => {
        this.service.deleteAnnualIncome(c.id).then(() => {
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Deleted Successfully...' });
          this.contactService.getAllAnnualIncome().then(incomes => {
            this.incomes = incomes;
          });
        }).catch(() => {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error occurred while deleting data...' });
        });
      },
      reject: () => {
      }
    });
  }
  delDegree(c) {
    this.confirmationService.confirm({
      message: this.userTranslate.DegreeDeleteConfirmationMsg,
      header: this.userTranslate.DeleteConfirmationHeader,
      icon: 'pi pi-info-circle',
      accept: () => {
        this.service.deleteDegree(c.id).then(() => {
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Deleted Successfully...' });
          this.contactService.getAllDegree().then(degrees => {
            this.degrees = degrees;
          });
        }).catch(() => {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error occurred while deleting data...' });
        });
      },
      reject: () => {
      }
    });
  }

  delStudyField(c) {
    this.confirmationService.confirm({
      message: this.userTranslate.DegreeDeleteConfirmationMsg,
      header: this.userTranslate.DeleteConfirmationHeader,
      icon: 'pi pi-info-circle',
      accept: () => {
        this.service.deleteStudyField(c.id).then(() => {
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Deleted Successfully...' });
          this.loadStudy();
        }).catch(() => {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error occurred while deleting data...' });
        });
      },
      reject: () => {
      }
    });
  }

  delEmailType(i) {
    this.confirmationService.confirm({
      message: this.userTranslate.EmailTyeDeleteConfirmationMsg,
      header: this.userTranslate.DeleteConfirmationHeader,
      icon: 'pi pi-info-circle',
      accept: () => {
        this.configTemp = {
          "id": this.emailConfig.id,
          "createdSource": this.app.userIP,
          "updatedSource": this.app.userIP,
          createdBy: this.app.user.userId,
          "updatedBy": this.app.user.organizationId,
          "createdDate": new Date().toISOString(),
          "updatedDate": new Date().toISOString(),
          "organizationId": this.emailConfig.organizationId,
          "name": this.emailConfig.name,
          "description": this.emailConfig.description,
          "configJSONSchema": "",
          "configJSONValue": "",
          "objectId": this.emailConfig.objectId,
          "levelId": this.emailConfig.levelId,
          "levelRecordId": this.emailConfig.configurationDetails[0].levelRecordId,
          "categoryId": this.emailConfig.categoryId,
          "statusId": 1,
          "typeId": this.emailConfig.typeId
        }
        this.emailtype.splice(i, 1);
        this.configTemp.configJSONValue = JSON.stringify(this.emailtype);

        this.service.updateConfiguration(this.configTemp).then(stages => {
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Deleted Successfully...' });
          // this.service.getAllConfiguration().subscribe(configs => {
          //   this.app.configurationData.next(configs);
          //   this.emailConfig = configs.filter(s => s.name == ObjectNames.CONTACTS_EMAIL_TYPES && s.typeId == 93)[0];
          //   this.emailtype = JSON.parse(this.emailConfig.configurationDetails[0].configJSONValue);
          // });
          this.getUserConfiguration();
        }).catch(() => {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error occurred while deleting data...' });
        });
      },
      reject: () => {
      }
    });
  }
  delPhoneType(i) {
    this.confirmationService.confirm({
      message: this.userTranslate.PhoneTypeDeleteConfirmationMsg,
      header: this.userTranslate.DeleteConfirmationHeader,
      icon: 'pi pi-info-circle',
      accept: () => {
        this.configTemp = {
          "id": this.phoneConfig.id,
          "createdSource": this.app.userIP,
          "updatedSource": this.app.userIP,
          createdBy: this.app.user.userId,
          "updatedBy": this.app.user.organizationId,
          "createdDate": new Date().toISOString(),
          "updatedDate": new Date().toISOString(),
          "organizationId": this.phoneConfig.organizationId,
          "name": this.phoneConfig.name,
          "description": this.phoneConfig.description,
          "configJSONSchema": "",
          "configJSONValue": "",
          "objectId": this.phoneConfig.objectId,
          "levelId": this.phoneConfig.levelId,
          "levelRecordId": this.phoneConfig.configurationDetails[0].levelRecordId,
          "categoryId": this.phoneConfig.categoryId,
          "statusId": 1,
          "typeId": this.phoneConfig.typeId
        }
        this.phonetype.splice(i, 1);
        this.configTemp.configJSONValue = JSON.stringify(this.phonetype);

        this.service.updateConfiguration(this.configTemp).then(stages => {
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Deleted Successfully...' });
          // this.service.getAllConfiguration().subscribe(configs => {
          //   this.app.configurationData.next(configs);
          //   this.phoneConfig = configs.filter(s => s.name == ObjectNames.CONTACTS_PHONE_TYPES && s.typeId == 93)[0];
          //   this.phonetype = JSON.parse(this.phoneConfig.configurationDetails[0].configJSONValue);
          // });
          this.getUserConfiguration();
        }).catch(() => {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error occurred while deleting data...' });
        });
      },
      reject: () => {
      }
    });
  }
  delSocialType(i) {
    this.confirmationService.confirm({
      message: this.userTranslate.SocialTypeDeleteConfirmationMsg,
      header: this.userTranslate.DeleteConfirmationHeader,
      icon: 'pi pi-info-circle',
      accept: () => {
        this.configTemp = {
          "id": this.socialConfig.id,
          "createdSource": this.app.userIP,
          "updatedSource": this.app.userIP,
          createdBy: this.app.user.userId,
          "updatedBy": this.app.user.organizationId,
          "createdDate": new Date().toISOString(),
          "updatedDate": new Date().toISOString(),
          "organizationId": this.socialConfig.organizationId,
          "name": this.socialConfig.name,
          "description": this.socialConfig.description,
          "configJSONSchema": "",
          "configJSONValue": "",
          "objectId": this.socialConfig.objectId,
          "levelId": this.socialConfig.levelId,
          "levelRecordId": this.socialConfig.configurationDetails[0].levelRecordId,
          "categoryId": this.socialConfig.categoryId,
          "statusId": 1,
          "typeId": this.socialConfig.typeId
        }
        this.socials.splice(i, 1);
        this.configTemp.configJSONValue = JSON.stringify(this.socials);

        this.service.updateConfiguration(this.configTemp).then(stages => {
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Deleted Successfully...' });
          // this.service.getAllConfiguration().subscribe(configs => {
          //   this.app.configurationData.next(configs);
          //   this.socialConfig = configs.filter(s => s.name == ObjectNames.CONTACTS_SOCIAL_TYPES && s.typeId == 95)[0];
          //   this.socials = JSON.parse(this.socialConfig.configurationDetails[0].configJSONValue);
          // });
          this.getUserConfiguration();
        }).catch(() => {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error occurred while deleting data...' });
        });
      },
      reject: () => {
      }
    });
  }

  deleteJobType(data): void {
    this.confirmationService.confirm({
      message: 'Do you want to delete this Job Type?',
      header: this.userTranslate.DeleteConfirmationHeader,
      icon: 'pi pi-info-circle',
      accept: () => {
        this.filteredJobTypes = [];
        this.jobTypeForTransfer = data;

        if (data?.noOfAssociatedUsers > 0) {
          this.displayTransferJobTypeModal = true;
          this.filteredJobTypes = this.jobTypes.filter(obj => obj?.name != data?.name);
        }
        else {
          this.transferAndDeleteJobType(true);
        }
      },
      reject: () => {
      }
    });
  }

  getNoOfAssociatedUsers(jobTypeId: number, isAddedNewUser = false): void {
    this.jobTypeIdForSelectedAssociatedUser = jobTypeId;
    this.appMainService.isShowSpinner('getNoOfAssociatedUsers');
    this.jobTypeService.getAssociatedUsers(this.jobTypeIdForSelectedAssociatedUser)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe({
        next: (response) => {
          this.associatedUsers = response;
          this.displayAssociatedUsersModal = true;
          if (isAddedNewUser) {
            this.getJobTypes();
          }
          this.appMainService.isHideSpinner('getNoOfAssociatedUsers');
        },
        error: ((error) => {
          this.appMainService.isHideSpinner('getNoOfAssociatedUsers');
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: error?.error?.Message ? error?.error?.Message : 'User lists are not loaded, please try again later..'
          });
        }),
        complete: (() => {
        })
      });
  }

  closeAssociatedUserModalOutputEvent(): void {
    this.displayAssociatedUsersModal = false;
    this.associatedUsers = [];
  }

  completedAddNewUser(): void {
    this.getNoOfAssociatedUsers(this.jobTypeIdForSelectedAssociatedUser, true);
  }

  transferAndDeleteJobType(directDeleteWitoutTransfer = false, transferAndDelete = false): void {
    if (!directDeleteWitoutTransfer && this.selectedJobTypeForTransfer?.name == undefined) {
      this.jobTypeSelectionError = true;
      return;
    }
    if (directDeleteWitoutTransfer || transferAndDelete) {
      const jobTypeData = {
        idforDelete: this.jobTypeForTransfer?.id,
        idforTransfer: directDeleteWitoutTransfer ? 0 : this.selectedJobTypeForTransfer?.id
      }
      this.jobTypeService.deleteJobType(jobTypeData?.idforDelete, jobTypeData?.idforTransfer).subscribe((response) => {
        this.displayTransferJobTypeModal = false;
        this.jobTypeForTransfer = null;
        this.getJobTypes();
        if (directDeleteWitoutTransfer) {
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Deleted Successfully...' });
        }
        else {
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Transfer and deleted successfully...' });
        }
      },
        (error) => {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: error?.Error ? error?.Error?.Message : 'Error occurred while transfer and delete data...'
          });

        });
    }
  }

  onChangeJobType($event) {
    if ($event?.value?.id) {
      this.jobTypeSelectionError = false;
    }
  }

  closeTransferJobTypeModal(): void {
    this.displayTransferJobTypeModal = false;
    this.selectedJobTypeForTransfer = false;
    this.jobTypeSelectionError = false;
  }


  getAllCountries(i) {
    this.accountService.getAllCountries().then(countries => {

      this.allCountries = [];
      this.filterValuesLists = [];
      this.filterValues[i] = [];
      for (let l of countries) {
        let eachCountry = {
          id: Number(l.id + ""),
          businessName: l.name,
        }
        this.allCountries.push(eachCountry);
      }


      this.filterValuesLists = JSON.parse(JSON.stringify(this.allCountries));
      this.filterValues[i] = JSON.parse(JSON.stringify(this.filterValuesLists));
    });

  }

  SelectAllCountries() {
    this.accountService.getAllCountries().then(countries => {
      let res = countries;
      this.countries = countries;
      for (let l of res) {
        let eachCountry = {
          id: Number(l.id + ""),
          businessName: l.name,
        }
        this.allCountries.push(eachCountry);
      }
      //this.allCountries=  JSON.parse(JSON.stringify(res));
    });

    // this.filters.push({ name: 'State', code: 'state' });
  }


  // getStates(value, stateName, cityName, ZipCode) {
  //   this.accountService.getAllStates(value.id).then(states => {
  //     let res = states;
  //     this.allStates = [];
  //     // let allStatesLists = []
  //     // this.filterValuesLists = [];
  //     //this.filterValues[i] = [];
  //     for (let l of res) {
  //       let eachState = {
  //         id: Number(l.id + ""),
  //         businessName: l.name,
  //       }
  //       this.allStates.push(eachState);
  //     }
  //     let stateId = this.allStates.filter(c => c.businessName == stateName)[0];
  //     // this.getCities(stateId,cityName)
  //     //this.ruleLists.fil
  //     //this.filterValuesLists = JSON.parse(JSON.stringify(allStatesLists));
  //     // this.filterValues[i] = JSON.parse(JSON.stringify(this.filterValuesLists));

  //     if (this.filters.filter(c => c.code == 'city').length == 0) {
  //       this.filters.push(
  //         { name: 'City', code: 'city' },
  //         { name: 'Zip Code', code: 'zip code' }
  //       );
  //     }

  //   });
  // }
  // getCities(value) {
  //   let stateIds: string;
  //   stateIds = '';
  //   value.forEach(element => {
  //     if (stateIds == '') {
  //       stateIds = element.id;
  //     }
  //     else {
  //       stateIds = stateIds + ',' + element.id;

  //     }
  //   });
  //   this.accountService.getAllCitiesByMultipleState(stateIds).then(cities => {
  //     //this.accountService.getAllCities(value[0].id).then(cities => {
  //     this.allCities = cities;
  //     this.allCitiesLists = []
  //     // this.filterValuesLists = [];
  //     //this.filterValues[i] = [];
  //     for (let l of this.allCities) {
  //       let eachCity = {
  //         id: Number(l.id + ""),
  //         businessName: l.name,
  //       }
  //       this.allCitiesLists.push(eachCity);
  //     }
  //   });
  // }



  tSelectedCounty = [];
  onNodeSelect(e) {
    ////console.log(this.tSelectedCounty);
  }




  addMessageField(notification, msg) {
    notification.message += "\n{" + msg + "}";
  }

  setStatesFromCountry(countryId, stateId, type?) {
    this.accountService.getAllStates(countryId).then(states => {
      let res = states;
      if (type == 'postal') {
        this.allPStates = [];
      } else {
        this.allStates = [];
      }
      if (res !== null) {
        let statesDetail: any[] = [];
        for (let l of res) {
          let eachState = {
            id: Number(l.id + ""),
            businessName: l.name,
          }

          if (type == 'postal') {
            if (stateId == eachState.id) {
              this.selectedPState = eachState;
            }
            this.allPStates.push(eachState);
          } else {
            if (stateId == eachState.id) {
              this.selectedMState = eachState;
            }
            statesDetail.push(eachState);
          }
        }
        this.allStates = statesDetail;
      }
    });
  }

  getStatesFromCountry(value, type?) {

    let stateIds: string;
    let values = value;
    stateIds = value.id;
    // value.forEach(element => {
    //   if (stateIds == '') {
    //     stateIds = element.id;
    //   }
    //   else {
    //     stateIds = stateIds + ',' + element.id;
    //   }
    // });

    this.accountService.getAllStatesByMultipleCountry(stateIds).then(states => {
      //this.countryIdMulti = value[0]?.id;
      //this.accountService.getAllStates(value[0]?.id).then(states => {
      let res = states;
      if (type == 'postal') {
        this.allPStates = [];
      } else {
        this.allStates = [];
      }
      // let allStatesLists = []
      // this.filterValuesLists = [];
      //this.filterValues[i] = [];
      let stateDetails: any[] = [];
      if (res !== null) {
        for (let l of res) {
          let eachState = {
            id: Number(l.id + ""),
            businessName: l.name,
          }
          // if (type == 'postal') {
          //  this.allPStates.push(eachState);
          //} else {
          stateDetails.push(eachState);
          // }
        }
        this.allStates = stateDetails;
      }
      //this.ruleLists.fil
      //this.filterValuesLists = JSON.parse(JSON.stringify(this.allStates));
      // this.filterValues[cnt+1] = JSON.parse(JSON.stringify(this.filterValuesLists));

      if (this.filters.filter(c => c.code == 'city').length == 0) {
        this.filters.push(
          { name: 'City', code: 'city' },
          { name: 'Zip Code', code: 'zip code' }
        );
      }
    });
  }

  getAllStates(i) {
    let allStatesLists: any[] = [];
    this.filterValuesLists = [];
    this.filterValues[i] = [];
    for (let l of this.allStates) {
      let eachState = {
        id: Number(l.id + ""),
        businessName: l.name,
      }
      allStatesLists.push(eachState);
    }
    this.filterValuesLists = JSON.parse(JSON.stringify(allStatesLists));
    this.filterValues[i] = JSON.parse(JSON.stringify(this.filterValuesLists));

    if (this.filters.filter(c => c.code == 'city').length == 0) {
      this.filters.push(
        { name: 'City', code: 'city' },
        { name: 'Zip Code', code: 'zip code' }
      );
    }
  }

  setCitiesFromState(stateId, cityId, type?) {
    this.accountService.getAllCities(stateId).then(cities => {
      if (type === 'postal') {
        this.selectedPCity = cities.find(obj => obj.id == cityId);
        this.allPCities = cities;
      } else {
        this.selectedMCity = cities.find(obj => obj.id == cityId);
        this.allCities = cities;
      }

    });
  }

  getCitiesFromState(value, type?) {
    this.accountService.getAllCities(value.id).then(cities => {
      if (type === 'postal') {
        this.allPCities = cities;
      } else {
        this.allCities = cities;
      }
    });
  }

  getCitiesFromStateQuestion(value, type?) {
    this.accountService.getAllCities(value[0].id).then(cities => {
      if (type === 'postal') {
        this.allPCities = cities;
      } else {
        this.allCities = cities;
      }
    });
  }

  getAllCities(i) {

    this.filterValuesLists = [];
    this.filterValues[i] = [];
    this.allCitiesLists = [];
    for (let l of this.allCities) {
      let eachCity = {
        id: Number(l.id + ""),
        businessName: l.name,
      }
      this.allCitiesLists.push(eachCity);
    }
    this.filterValuesLists = JSON.parse(JSON.stringify(this.allCitiesLists));
    this.filterValues[i] = JSON.parse(JSON.stringify(this.filterValuesLists));
  }

  getStateCity(e) {
    if (e.node.type == 'Country') {
      if (e.node.children.length < 2) {
        this.service.getStatesByCountryId(e.node.id).then(res => {
          let states: any[] = [];
          for (let s of res) {
            let temp = {
              id: s.id,
              countryId: s.countryId,
              label: s.name,
              statusId: s.statusId,
              type: 'State',
              children: [{}],
            }
            states.push(temp);
          }
          e.node.children = JSON.parse(JSON.stringify(states));
        });
      }
    }
    if (e.node.type == 'State') {
      if (e.node.children.length < 2) {
        this.service.getCitiesByStateId(e.node.id).then(res => {
          let cities: any[] = [];
          for (let s of res) {
            let temp = {
              id: s.id,
              countryId: s.countryId,
              label: s.name,
              statusId: s.statusId,
              type: 'City'
            }
            cities.push(temp);
          }
          e.node.children = JSON.parse(JSON.stringify(cities));
        });
      }
    }
  }

  getReportConfigData(userID) {
    this.service.getUserPermissionsReport(userID).then(res => {
      let rr = res;
      this.reportPermissionData = [];
      let reportpermission = JSON.parse(JSON.stringify(res));
      ////console.log('reportpermission');
      ////console.log(reportpermission);
      let permissionDetails: any[] = [];
      let parentreportPer = reportpermission.filter(c => c.parentObjectId == 0 || c.parentObjectId == null);
      parentreportPer.forEach(pelement => {
        // ////console.log(element.objectName);
        permissionDetails = [];
        let parentreportPerDetails = reportpermission.filter(c => c.parentObjectId == pelement.objectId);

        const pExportIndex = pelement.permissions.findIndex(per => per.permissionName.toLowerCase() == "export");
        const pViewIndex = pelement.permissions.findIndex(per => per.permissionName.toLowerCase() == "read");

        parentreportPerDetails.forEach(element => {

          const exportIndex = pelement.permissions.findIndex(per => per.permissionName.toLowerCase() == "export");
          const viewIndex = pelement.permissions.findIndex(per => per.permissionName.toLowerCase() == "read");

          let dd = {
            "data":
            {
              "objectId": element.objectId,
              "parentobjectId": pelement.objectId,
              "name": element.objectName,
              "view": element.permissions[viewIndex].statusId === 1 ? true : false,
              "export": element.permissions[exportIndex].statusId === 1 ? true : false,
              "viewPermissionId": element.permissions[viewIndex].permissionId,
              "exportPermissionId": element.permissions[exportIndex].permissionId,
              "viewId": element.permissions[viewIndex].id,
              "exportId": element.permissions[exportIndex].id
            }
          }
          permissionDetails.push(dd);
        });
        if (parentreportPerDetails.length !== 0) {
          let rrr = {
            "data": {
              "objectId": pelement.objectId,
              "parentobjectId": 0,
              "name": pelement.objectName,
              "view": pelement.permissions[pViewIndex].statusId === 1 ? true : false,
              "export": pelement.permissions[pExportIndex].statusId === 1 ? true : false,
              "viewPermissionId": pelement.permissions[pViewIndex].permissionId,
              "exportPermissionId": pelement.permissions[pExportIndex].permissionId,
              "viewId": pelement.permissions[pViewIndex].id,
              "exportId": pelement.permissions[pExportIndex].id
            },
            "children": permissionDetails
          }

          this.reportPermissionData.push(rrr);
        } else {
          let rrr = {
            "data": {
              "objectId": pelement.objectId,
              "parentobjectId": 0,
              "name": pelement.objectName,
              "view": pelement.permissions[pViewIndex].statusId === 1 ? true : false,
              "export": pelement.permissions[pExportIndex].statusId === 1 ? true : false,
              "viewPermissionId": pelement.permissions[pViewIndex].permissionId,
              "exportPermissionId": pelement.permissions[pExportIndex].permissionId,
              "viewId": pelement.permissions[pViewIndex].id,
              "exportId": pelement.permissions[pExportIndex].id
            },

            "children": []
          }
          this.reportPermissionData.push(rrr);
        }
      });
    });
  }

  addJobType(): void {
    let jobTypesToLower: any[] = [];
    for (let s of this.jobTypes) {
      jobTypesToLower.push(s.name.toLowerCase())
    }
    if (jobTypesToLower.indexOf(this.contactDataTemp.name.toLowerCase()) > -1) {
      this.invalidData = true;
    } else {
      this.jobTypeService.addJobType(this.contactDataTemp).subscribe(response => {
        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Job Type added Successfully...' });
        this.getJobTypes();
        this.displayAddContactData = false;
        this.selectedContactDataType = null
      });
    }
  }

  editJobType(): void {
    if (!this.contactDataTemp.name) {
      this.contactDataFormSubmitted = true;
      this.fieldTypeSelectionError = true;
      return;
    }

    const duplicateRecord = this.jobTypes.find(obj => obj?.name.toLowerCase() == this.contactDataTemp?.name.toLowerCase() && obj?.id !== this.contactDataTemp?.id)
    if (duplicateRecord) {
      this.invalidData = true;
    } else {
      this.invalidData = false;
    }

    if (!this.invalidData) {
      this.jobTypeService.updateJobType(this.contactDataTemp).subscribe(Response => {
        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Job type updated Successfully...' });
        this.getJobTypes();
        this.displayAddContactData = false;
        this.selectedContactDataType = null;
      });
    }
  }

  closeAddEditFieldDataPopup(): void {
    this.displayAddContactData = false;
    this.invalidData = false;
  }

  getRoleHierarchyList(data): void {
    // this.appMainService.isShowSpinner("getRoleHierarchyList");
    // this.roleHierarchyService
    //   .getAllRoleHierarchy()
    //   .pipe(takeUntil(this.ngUnsubscribe))
    //   .subscribe({
    //     next: (response) => {
    //       const data = response;
    //       const convertedData = this.convertJsonForTreeSelect(data);
    //       this.allRoleHierarchy = JSON.parse(
    //         JSON.stringify(convertedData)
    //       );
    //       this.appMainService.isHideSpinner("getRoleHierarchyList");
    //     },
    //     error: (error) => {
    //       this.appMainService.isHideSpinner("getRoleHierarchyList");
    //       this.messageService.add({
    //         severity: "error",
    //         summary: "Error",
    //         detail: error?.error?.Message
    //           ? error?.error?.Message
    //           : "Role lists are not loaded, please try again later..",
    //       });
    //     },
    //     complete: () => { },
    //   });
    const convertedData = this.convertJsonForTreeSelect(data);
    this.allRoleHierarchy = JSON.parse(
      JSON.stringify(convertedData)
    );
  }

  convertJsonForTreeSelect(inputJson) {
    return inputJson.map((item) => ({
      ...item,
      label: item.roleName,
      children: this.convertJsonForTreeSelect(item.childRoleDTO),
    }));
  }

  getSelectedRoleHierarchy(roleId) {
    for (let s of this.allRoleHierarchy) {
      this.selectedRoleHierarchy = this.searchInTree(s, roleId);
      if (this.selectedRoleHierarchy != null) {
        break;
      }
    }
  }

  searchInTree(element, id): void {
    if (element.id == id) {
      return element;
    } else if (element.children != null) {
      var i;
      var result = null;
      for (i = 0; result == null && i < element.children.length; i++) {
        result = this.searchInTree(element.children[i], id);
      }
      return result;
    }
    return null;
  }

  getProfileList(): void {
    this.appMainService.isShowSpinner('getProfileList');
    this.userProfileService.getAllProfile()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe({
        next: (response) => {
          this.allProfile = response;
          this.appMainService.isHideSpinner('getProfileList');
        },
        error: ((error) => {
          this.appMainService.isHideSpinner('getProfileList');
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: error?.error?.Message ? error?.error?.Message : 'Profile lists are not loaded, please try again later..'
          });
        }),
        complete: (() => {
        })
      });
  }

  getSystemDefaultChannel(): void {
    this.appMainService.isShowSpinner('getSystemDefaultChannel');
    this.userProfileService.getSystemDefaultChannel()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe({
        next: (response) => {
          this.systemDefaultChannelPermission = response;
          this.appMainService.isHideSpinner('getSystemDefaultChannel');
        },
        error: ((error) => {
          this.appMainService.isHideSpinner('getSystemDefaultChannel');
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: error?.error?.Message ? error?.error?.Message : 'Default channel permission not loaded, please try again later..'
          });
        }),
        complete: (() => {
        })
      });
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  //permission
  addPermission() {
    this.filterChannel();
    if (this.channelsN.length === 0) {
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'All channels are configured successfully...'
      });
    }
    else {
      this.permissionHeader = "Add Permission";
      this.tempPermission = {
        id: 0,
        channelName: "",
        channelID: 0,
        userProfileName: "",
        userProfileID: 0,
        isActive: true,
        isDefault: false,
        userId: 0,
        statusId: 1
      }
      this.selectedProfile = this.allProfile[0];
      this.selectedChannelN = this.channelsN[0];
      this.displayAddEditPermission = true;
    }
  }

  editPermission(editData, index) {
    this.indexOfEditPermissionData = index;
    this.filterChannel(true, editData);
    this.permissionHeader = "Edit Permission";
    this.tempPermission = JSON.parse(JSON.stringify(editData));
    this.selectedChannelN = this.channelsVM.find((x) => x.id === editData?.channelID);
    this.selectedProfile = this.allProfile.find((x) => x.id === editData?.userProfileID);
    this.permissionActiveInactiveToggle = editData?.isActive;
    this.displayAddEditPermission = true;
  }

  async filterChannel(fromEdit: boolean = false, editData?) {

    const matchingObj = this.channelsVM.find(obj => obj?.id == editData?.channelID);
    const additionalObj = {
      id: matchingObj?.id,
      name: matchingObj?.name,
      isDefault: matchingObj?.isDefault
    }

    const modifiedChannel = this.channelsVM.filter(obj => !this.permissionsTB.some(sobj =>
      sobj.channelID === obj.id
    ));

    const indexOfChannel = this.channelsVM.findIndex(obj => obj.id === additionalObj?.id);

    if (fromEdit && indexOfChannel >= 0) {
      modifiedChannel.splice(indexOfChannel, 0, additionalObj);
    }

    this.channelsN = [];
    this.channelsN = modifiedChannel;
  }

  deletePermission(permissionData, index) {

    if (permissionData?.id > 0) {
      this.permissionsTB[index].statusId = 3;
      this.deletedPermissionsTB.push(this.permissionsTB[index])
    }

    this.permissionsTB.splice(index, 1);

    // if (permissionData?.userId === 0){
    //   if (index >= 0 && index < this.permissionsTB.length){
    //     this.permissionsTB.splice(index, 1);
    //   }
    // }
    // else {
    //   this.appMainService.isShowSpinner('deletePermission');
    //   this.channelWisePermissionService.deleteChannelPermission(permissionData?.id)
    //       .pipe(takeUntil(this.ngUnsubscribe))
    //       .subscribe(
    //           {
    //               next: (response) => {
    //                 const user = {
    //                   id: permissionData?.userId
    //                 }
    //                 this.showEditUser(user, 'edit');
    //                 this.appMainService.isHideSpinner('deletePermission');
    //                 this.messageService.add({
    //                   severity: 'success',
    //                   summary: 'Success',
    //                   detail: 'Default changed successfully...'
    //                 });
    //               },
    //               error: (error) => {
    //                   this.appMainService.isHideSpinner('deletePermission');
    //                   this.messageService.add({
    //                       severity: 'error',
    //                       summary: 'Error',
    //                       detail: error?.error?.message ? error?.error?.message : 'Error occurred, please try again...'
    //                   });

    //               },
    //               complete: () => {
    //               },
    //           });
    // }

  }

  savePermission() {
    const permissionData = {
      channelName: this.selectedChannelN?.name,
      channelID: this.selectedChannelN?.id,
      userProfileID: this.selectedProfile?.id,
      userProfileName: this.selectedProfile?.name,
      isDefault: this.tempPermission.isDefault,
      isActive: this.permissionActiveInactiveToggle,
      userId: this.userForChannelPermission?.id ? this.userForChannelPermission?.id : 0,
      id: this.tempPermission?.id ? this.tempPermission?.id : 0
    }
    if (this.permissionHeader == "Add Permission") {
      this.addChannelPermission(permissionData);
    } else if (this.permissionHeader == "Edit Permission") {
      this.editStoredPermission(permissionData);
      //   if (this.addEditUserHeader == 'Add User'){
      //     this.editStoredPermission(permissionData);
      //   }
      //   else {
      //     const updatePermissionData = {
      //       channelId: permissionData?.channelID,
      //       userProfileID: permissionData?.userProfileID,
      //       id: permissionData?.id,
      //       isActive: permissionData?.isActive,
      //       isDefault: permissionData?.isDefault,
      //       userId: permissionData?.userId
      //     }
      //     this.editChannelPermission(updatePermissionData);
      //   }

    }
    this.displayAddEditPermission = false;
  }

  editStoredPermission(permissionData) {
    if (this.indexOfEditPermissionData >= 0 && this.indexOfEditPermissionData < this.permissionsTB.length) {
      this.permissionsTB[this.indexOfEditPermissionData] = {
        ...this.permissionsTB[this.indexOfEditPermissionData], ...permissionData
      }
    }
  }

  makeDefaultPermission(permissionData, index) {

    this.permissionsTB.map(permission => {
      permission.isDefault = false;
    })
    this.permissionsTB[index].isDefault = true;

    // if (permissionData?.id === 0){
    //   if (index >= 0 && index < this.permissionsTB.length){
    //     this.permissionsTB.map(permission=> {
    //         permission.isDefault = false;
    //     })
    //     this.permissionsTB[index].isDefault = true;
    //   }
    // }
    // else {
    //   this.appMainService.isShowSpinner('makePermissionDefault');
    //   this.channelWisePermissionService.makeDefaultPermission(permissionData?.userId, permissionData?.id)
    //       .pipe(takeUntil(this.ngUnsubscribe))
    //       .subscribe(
    //           {
    //               next: (response) => {
    //                 const user = {
    //                   id: permissionData?.userId
    //                 }
    //                 this.showEditUser(user, 'edit');
    //                 this.appMainService.isHideSpinner('makePermissionDefault');
    //                 this.messageService.add({
    //                   severity: 'success',
    //                   summary: 'Success',
    //                   detail: 'Default changed successfully...'
    //                 });
    //               },
    //               error: (error) => {
    //                   this.appMainService.isHideSpinner('makePermissionDefault');
    //                   this.messageService.add({
    //                       severity: 'error',
    //                       summary: 'Error',
    //                       detail: error?.error?.message ? error?.error?.message : 'Error occurred, please try again...'
    //                   });

    //               },
    //               complete: () => {
    //               },
    //           });
    // }

  }

  getChannels(): void {
    this.appMainService.isShowSpinner('getChannel');
    this.sharedChannelService.getAllChannels(AccountModuleId)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        {
          next: (response) => {
            this.channelsN = response || [];
            this.channelsVM = response || [];
            this.selectedChannelN = response.find(x => x?.isDefault == true);
            this.appMainService.isHideSpinner('getChannel');
          },
          error: (error) => {
            this.appMainService.isHideSpinner('getChannel');
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: error?.error?.message ? error?.error?.message : 'Channels are not loaded, please try again...'
            });

          },
          complete: () => {
            //this.getChannelStage(this.selectedChannelN?.id);
          },
        });
  }

  addChannelPermission(permissionData): void {
    this.permissionsTB.push(permissionData);
  }

  editChannelPermission(permissionData): void {
    this.appMainService.isShowSpinner('editChannelPermission');
    this.channelWisePermissionService.editChannelPermission(permissionData)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        {
          next: (response) => {
            const user = {
              id: permissionData?.userId
            }
            this.showEditUser(user, 'edit');
            this.appMainService.isHideSpinner('editChannelPermission');
          },
          error: (error) => {
            this.appMainService.isHideSpinner('editChannelPermission');
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: error?.error?.message ? error?.error?.message : 'Error occured, please try again...'
            });

          },
          complete: () => {
            //this.getChannelStage(this.selectedChannelN?.id);
          },
        });
  }

  reloadLoggedUserPermissions() {
    this.appMainService.isShowSpinner('UserPemissions');
    this.permissionService.getUserPermissions().subscribe(
      resp => {
        this.appMainService.isHideSpinner('UserPemissions');
      },
      err => {
        this.appMainService.isHideSpinner('UserPemissions');
      }
    )
  }

  onRemoveAddressLocation(event, addressType: string) {
    if (addressType === 'main') {
      this.addressInput = "";
      this.formattedaddress = "";
      this.formattedAddressForPostal = "";
      this.selectedMCountry = null;
      this.selectedMState = null;
      this.selectedMCity = null;
      this.tempUser.mainAddress.zipCode = "";
    } else if (addressType === 'postal') {
      this.addressInputForPostal = "";
      this.formattedAddressForPostal = "";
      this.selectedPCountry = null;
      this.selectedPState = null;
      this.selectedPCity = null;
      this.tempUser.postalAddress.zipCode = "";
    }
  }

  onAddressBlur(address, addressType: string) {
    if (addressType === 'main') {
      this.addressInput = address;
      this.formattedaddress = this.addressInput;
      if (address == "") {
        this.addressInput = '';
        this.formattedaddress = '',
          this.selectedMCountry = null;
        this.selectedMState = null;
        this.selectedMCity = null;
        this.tempUser.mainAddress.zipCode = "";
      }
    }
    else if (addressType === 'postal') {
      this.addressInputForPostal = address;
      this.formattedAddressForPostal = this.addressInputForPostal;
      if (address === '') {
        this.selectedPCountry = null;
        this.selectedPState = null;
        this.selectedPCity = null;
        this.tempUser.postalAddress.zipCode = '';
      }
    }
  }

  async onAddressChanged(address: any, addressType: string) {
    this.onRemoveAddressLocation(address, addressType);
    if (addressType === 'main') {
      this.formattedaddress = address.formatted_address;
    } else if (addressType === 'postal') {
      this.formattedAddressForPostal = address.formatted_address;
    }

    const googleAddressObj = this.getAddressObj(address);
    // console.log("getAddressObj", googleAddressObj);
    setTimeout(() => {
      const da = this.getStreetAddres(googleAddressObj); //updatedAddressLine;
      if (addressType === 'main') {
        this.addressInput = da;
        this.formattedaddress = da;
      } else if (addressType === 'postal') {
        this.addressInputForPostal = da;
        this.formattedAddressForPostal = da;
      }
      //console.log('formattedaddress', this.formattedaddress)
    });
    if (addressType === 'main') {
      this.latitude = googleAddressObj.latitude;
      this.longitude = googleAddressObj.longitude;
      let searchedCountry = googleAddressObj.country
        ? googleAddressObj.country.long_name
        : "";
      let searchedZipcode = googleAddressObj.zipCode
        ? googleAddressObj.zipCode.long_name
        : "";
      let searchedState = googleAddressObj.state
        ? googleAddressObj.state.long_name
        : "";
      let searchedCity = googleAddressObj.city
        ? googleAddressObj.city.long_name
        : "";
      if (searchedCountry) {
        let matchedCountry;
        if (
          searchedCountry == "USA" ||
          searchedCountry == "United States"
        ) {
          matchedCountry = this.countries.find(
            (obj) =>
              obj.name == searchedCountry ||
              obj.countryCode == googleAddressObj.country.short_name
          );
        } else {
          matchedCountry = this.countries.find(
            (obj) => obj.name == searchedCountry
          );
        }
        this.selectedMCountry = matchedCountry;
        //set zipcode
        if (searchedZipcode) {
          this.tempUser.mainAddress.zipCode = searchedZipcode;
        }

        if (matchedCountry) {
          this.appMainService.isShowSpinner("loadStates");
          this.allStates = await this.getStates(matchedCountry);
          this.appMainService.isHideSpinner("loadStates");

          if (searchedState) {
            //set state
            let matchedState = this.allStates.find(
              (obj) =>
                obj.name == searchedState ||
                obj.shortName == googleAddressObj.state.short_name
            );
            if (!matchedState) {
              // add state
              matchedState = await this.addState(
                googleAddressObj.state,
                matchedCountry.id
              );
            }
            this.appMainService.isShowSpinner("loadCity");
            this.allCities = await this.getCities(matchedState);
            this.appMainService.isHideSpinner("loadCity");
            this.selectedMState = matchedState;

            if (searchedCity) {
              //set city
              let matchedCity = this.allCities
                ? this.allCities.find(
                  (obj) => obj.name == searchedCity
                )
                : null;
              if (!matchedCity) {
                matchedCity = await this.addCity(
                  searchedCity,
                  matchedState.id
                );
              }
              this.selectedMCity = matchedCity;
            }
          }
        }
      }


    } else if (addressType === 'postal') {

      this.latitude = googleAddressObj.latitude;
      this.longitude = googleAddressObj.longitude;
      let searchedCountry = googleAddressObj.country
        ? googleAddressObj.country.long_name
        : "";
      let searchedZipcode = googleAddressObj.zipCode
        ? googleAddressObj.zipCode.long_name
        : "";
      let searchedState = googleAddressObj.state
        ? googleAddressObj.state.long_name
        : "";
      let searchedCity = googleAddressObj.city
        ? googleAddressObj.city.long_name
        : "";
      if (searchedCountry) {
        let matchedCountry;
        if (
          searchedCountry == "USA" ||
          searchedCountry == "United States"
        ) {
          matchedCountry = this.countries.find(
            (obj) =>
              obj.name == searchedCountry ||
              obj.countryCode == googleAddressObj.country.short_name
          );
        } else {
          matchedCountry = this.countries.find(
            (obj) => obj.name == searchedCountry
          );
        }

        this.selectedPCountry = matchedCountry;
        //set zipcode
        if (searchedZipcode) {
          this.tempUser.postalAddress.zipCode = searchedZipcode;
        }

        if (matchedCountry) {
          this.appMainService.isShowSpinner("loadStates");
          this.allPStates = await this.getStates(matchedCountry);
          this.appMainService.isHideSpinner("loadStates");

          if (searchedState) {
            //set state
            let matchedState = this.allPStates.find(
              (obj) =>
                obj.name == searchedState ||
                obj.shortName == googleAddressObj.state.short_name
            );
            if (!matchedState) {
              // add state
              matchedState = await this.addState(
                googleAddressObj.state,
                matchedCountry.id
              );
            }
            this.appMainService.isShowSpinner("loadCity");
            this.allPCities = await this.getCities(matchedState);
            this.appMainService.isHideSpinner("loadCity");
            this.selectedPState = matchedState;

            if (searchedCity) {
              //set city
              let matchedCity = this.allPCities
                ? this.allPCities.find(
                  (obj) => obj.name == searchedCity
                )
                : null;
              if (!matchedCity) {
                matchedCity = await this.addCity(
                  searchedCity,
                  matchedState.id
                );
              }
              this.selectedPCity = matchedCity;
            }
          }
        }
      }
    }

  }

  getAddressObj(address) {
    const addressObj = {
      street_number: null,
      subpremise: null,
      plus_code: null,
      neighborhood: null,
      landmark: null,
      route: null,
      sublocality_level_3: null,
      sublocality_level_2: null,
      sublocality_level_1: null,
      locality: null,
      city: null,
      state: null,
      country: null,
      zipCode: null,
      latitude: address.geometry.location.lat(),
      longitude: address.geometry.location.lng(),
    };
    address.address_components.forEach((comp) => {
      const field = comp.types[0];
      if (field == "street_number") {
        addressObj.street_number = comp;
      }
      if (field == "plus_code") {
        addressObj.plus_code = comp;
      }
      if (field == "neighborhood") {
        addressObj.neighborhood = comp;
      }
      if (field == "landmark") {
        addressObj.landmark = comp;
      }
      if (field == "route") {
        addressObj.route = comp;
      }
      if (field == "sublocality_level_3") {
        addressObj.sublocality_level_3 = comp;
      }
      if (field == "sublocality_level_2") {
        addressObj.sublocality_level_2 = comp;
      }
      if (field == "sublocality_level_1") {
        addressObj.sublocality_level_1 = comp;
      }
      if (field == "subpremise") {
        addressObj.subpremise = comp;
      }
      // city
      if (field == "locality") {
        addressObj.locality = comp;
        addressObj.city = comp;
      }
      // // city
      // if(field =='administrative_area_level_2'){
      //     addressObj.city = comp;
      // }
      // state
      if (field == "administrative_area_level_1") {
        addressObj.state = comp;
      }

      if (field == "country") {
        addressObj.country = comp;
      }
      if (field == "postal_code") {
        addressObj.zipCode = comp;
      }
    });
    if (addressObj.city == null) {
      addressObj.city = addressObj.sublocality_level_1;
    }
    return addressObj;
  }

  getStreetAddres(googleAddressObj) {
    const street = [];
    if (googleAddressObj.plus_code) {
      street.push(googleAddressObj.plus_code.long_name);
    }
    if (googleAddressObj.street_number) {
      street.push(googleAddressObj.street_number.long_name);
    }
    if (googleAddressObj.route) {
      street.push(googleAddressObj.route.long_name);
    }
    if (googleAddressObj.subpremise) {
      street.push(`#${googleAddressObj.subpremise.long_name}`);
    }
    if (googleAddressObj.neighborhood) {
      street.push(googleAddressObj.neighborhood.long_name);
    }
    if (googleAddressObj.sublocality_level_3) {
      street.push(googleAddressObj.sublocality_level_3.long_name);
    }
    if (googleAddressObj.sublocality_level_2) {
      street.push(googleAddressObj.sublocality_level_2.long_name);
    }
    if (
      googleAddressObj.sublocality_level_1 &&
      googleAddressObj.locality != null
    ) {
      street.push(googleAddressObj.sublocality_level_1.long_name);
    }
    // if(googleAddressObj.locality){
    //     street.push(googleAddressObj.locality.long_name);
    // }
    return street.length ? street.join(" ") : "";
  }

  getStates(country) {
    if (country && country.id) {
      return this.addEditAddressModalService.getAllStates(country.id);
    } else {
      return [];
    }
  }

  getCities(state) {
    if (state && state.id) {
      return this.addEditAddressModalService.getAllCities(state.id);
    } else {
      return [];
    }
  }

  async addCity(searchedCityName, stateId) {
    const data = {
      id: 0,
      createdSource: this.app.user.userIP,
      updatedSource: null,
      createdBy: this.app.user.userId,
      updatedBy: 0,
      createdDate: new Date(),
      updatedDate: null,
      name: searchedCityName,
      description: searchedCityName,
      stateId: stateId,
      statusId: 1,
    };
    //console.log('new city data', data)
    this.appMainService.isShowSpinner("addNewCity");
    const newAddedCity = await this.addEditAddressModalService.addCity(
      data
    );
    //console.log('added city', newAddedCity)
    this.cityList = addInList(this.cityList, newAddedCity);
    this.appMainService.isHideSpinner("addNewCity");
    return newAddedCity;
  }

  async addState(stateDetails, countryId) {
    const data = {
      id: 0,
      createdSource: this.app.user.userIP,
      updatedSource: null,
      createdBy: this.app.user.userId,
      updatedBy: 0,
      createdDate: new Date(),
      updatedDate: null,
      name: stateDetails.long_name,
      shortName: stateDetails.short_name,
      description: stateDetails.long_name,
      countryId: countryId,
      statusId: 1,
    };
    this.appMainService.isShowSpinner("addNewState");
    const newAddedState = await this.addEditAddressModalService.addState(
      data
    );
    this.allStates = addInList(this.stateList, newAddedState);
    this.appMainService.isHideSpinner("addNewState");
    return newAddedState;
  }

  async loadCountryStates(addressType: string, selectedMCountry?: any, selectedStateId?: number) {
    if (addressType === 'main') {
      this.allStates = await this.getStates(selectedMCountry || this.selectedMCountry);
      if (selectedStateId) {
        const selectedMState = this.allStates.find((state) => state.id === selectedStateId);
        this.selectedMState = selectedMState;
      }

    } else if (addressType === 'postal') {
      this.allPStates = await this.getStates(selectedMCountry || this.selectedPCountry);
      if (selectedStateId) {
        const selectedPState = this.allPStates.find((state) => state.id === selectedStateId);
        this.selectedPState = selectedPState;
      }
    }
  }

  async loadCountryCities(addressType: string, selectedMState?: any, selectedCityId?: number) {
    if (addressType === 'main') {
      this.allCities = await this.getCities(selectedMState || this.selectedMState);
      if (selectedCityId) {
        this.selectedMCity = this.allCities.find((state) => state.id === selectedCityId);

      }
    } else if (addressType === 'postal') {
      this.allPCities = await this.getCities(selectedMState || this.selectedPState);
      if (selectedCityId) {
        this.selectedPCity = this.allPCities.find((state) => state.id === selectedCityId);
      }
    }

  }

  onLocationChange(event: any) {

    this.selectedWorkingLocation = [event.value]; // Store the selected value in an array
  }

  getTimeZoneId() {
    this.service.getTimeZoneId(this.app.organizationData?.id).subscribe({
      next: (response) => {
        this.timeZoneId = response;
      },
      error: (error) => {
        this.messageService.add({
          severity: "error",
          summary: "Error",
          detail: error?.error?.Message ? error?.error?.Message : `Failed to load timezone..`,
        });
        this.appMainService.isHideSpinner('updateRootTerritory');
      },
    });
  }


  filterUsers() {
    if (this.isActive) {
      // Show only active users (statusId: 1)
      this.allUsersList  = this.allUsers.filter(user => user.statusId === 1);
    } else {
      // Show only inactive users (statusId !== 1)
      this.allUsersList  = this.allUsers.filter(user => user.statusId !== 1);
    }
  }
  
}
